import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "161ec63b-1b36-486e-b50e-3fce09959017"
// title: "Polytopia 2025 Presenters"
// type: :html
// key: "polytopia-2025-presenters"
// parent_id: nil
export function Polytopia2025Presenters161ec63b1b36486eB50e3fce09959017(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2025Presenters161ec63b1b36486eB50e3fce09959017 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="HeaderBe9a936fF4ef404fB5feDa9b95a18828" parentTag={buildClassName("HeaderBe9a936fF4ef404fB5feDa9b95a18828", parentTag)} className="public-header-with-hero secondary-page" as="header" contentSlug="polytopia-2025-presenters-header-with-hero" subType="header_with_hero" {...props} />}
      <main>
        {props["intro"] || <ContentSnippet className="Intro802d08a7582148719f0bA58951f4df72" parentTag={buildClassName("Intro802d08a7582148719f0bA58951f4df72", parentTag)} contentSlug="polytopia-2025-presenters-intro-text" className="intro-text" {...props} />}
        {props["cards"] || <MarketingCards className="Cards49c5dba9Edc5491dB9cf622db50f5735" parentTag={buildClassName("Cards49c5dba9Edc5491dB9cf622db50f5735", parentTag)} postSlug="polytopia-2025-presenters-cards" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer9683a88fE78644bdB33cEfaa37c55090" {...props} />}
    </div>
  );
}

// id: "e635450e-5253-445a-b71e-02ef84358c46"
// title: "Common Footer"
// type: :reference
// key: "footer"
// parent_id: nil
export function FooterE635450e5253445aB71e02ef84358c46(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="FooterE635450e5253445aB71e02ef84358c46" {...props} />
  );
}

// id: "a37c2102-173c-4d49-a14a-f3f10597a1f5"
// title: "Members Area"
// type: :html
// key: "members-area-default"
// parent_id: nil
export function MembersAreaDefaultA37c2102173c4d49A14aF3f10597a1f5(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MembersAreaDefaultA37c2102173c4d49A14aF3f10597a1f5 page`}>
      {props["header"] || <MembersAreaHeaderF9d2c204Ca514b8bA2a4A44a7305a5fd parentTag="HeaderA3c1651dF4634b359ce1C094693dba72" navMenuSlug="members-primary-nav" {...props} />}
      {props["footer"] || <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="FooterD2d37f8a8ab04b1bAd124dc21d463dd4" {...props} />}
    </div>
  );
}

// id: "f9d2c204-ca51-4b8b-a2a4-a44a7305a5fd"
// title: "Members Area Header"
// type: :reference
// key: "members-area-header"
// parent_id: nil
export function MembersAreaHeaderF9d2c204Ca514b8bA2a4A44a7305a5fd(props: any) {
  return (
    <ShortHeader23d209925bf248b39101Af66f3618c42 parentTag="MembersAreaHeaderF9d2c204Ca514b8bA2a4A44a7305a5fd" header-top={<DefaultHeaderTopB6c2307bD6814f14A258B20d9016e163 parentTag="HeaderTop72421d8b740d40bb97d2A03507bc304d" navMenuSlug="members-primary-nav" />} {...props} />
  );
}

// id: "b6c2307b-d681-4f14-a258-b20d9016e163"
// title: "Header Area Top"
// type: :html
// key: "default-header-top"
// parent_id: nil
export function DefaultHeaderTopB6c2307bD6814f14A258B20d9016e163(props: any) {
  const Link = AppStore.presets["Link"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultHeaderTopB6c2307bD6814f14A258B20d9016e163 header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogo163ca03aAe8e434b91123c65cee9700d" parentTag={buildClassName("LinkedLogo163ca03aAe8e434b91123c65cee9700d", parentTag)} label={<DefaultLogo61ee95b52f514b33A182C65924ce10ad parentTag="LabelC97f69a364b343d5956c9becc05b7e1c" alt="logo" />} className="linked-logo" url="/" {...props} />}
      {props["navigation"] || <PrimaryNavigation className="NavigationAf40ecc3685646f7B38eDfee76dd4b1c" parentTag={buildClassName("NavigationAf40ecc3685646f7B38eDfee76dd4b1c", parentTag)} navMenuSlug="marketing-primary-nav" className="navigation" {...props} />}
    </div>
  );
}

// id: "b5bdf197-84c6-4598-ba9a-e3cca29275dd"
// title: "Marketing Cards"
// type: :gf_preset
// key: "marketing-cards"
// parent_id: nil
export function MarketingCardsB5bdf19784c64598Ba9aE3cca29275dd(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="MarketingCardsB5bdf19784c64598Ba9aE3cca29275dd" parentTag={buildClassName("MarketingCardsB5bdf19784c64598Ba9aE3cca29275dd", parentTag)} postSlug="home-page-posts2" buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" {...props} />
  );
}

// id: "2c6604e0-3fd4-4a62-a699-10a54631f001"
// title: "Polytopia 2024"
// type: :html
// key: "polytopia-2024"
// parent_id: nil
export function Polytopia20242c6604e03fd44a62A69910a54631f001(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia20242c6604e03fd44a62A69910a54631f001 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeader46e8287a4bfb4421A3bdAdd5b7823e32 parentTag="HeaderA75825ab16ea4b46875944fd1e10c499" title="Polytopia 2024" {...props} />}
      <main>
        {props["body"] || <MarketingCardsB5bdf19784c64598Ba9aE3cca29275dd parentTag="Body516d7bfbB25b4173A1a66fdeb815cdb4" postSlug="polytopia-2024" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer5df4a4ad93b24322B06a1e233b044515" {...props} />}
    </div>
  );
}

// id: "31431831-0fb1-4e5f-880b-b30691a5f62e"
// title: "Signup Pages"
// type: :reference
// key: "signup-pages"
// parent_id: nil
export function SignupPages314318310fb14e5f880bB30691a5f62e(props: any) {
  return (
    <SecondaryPage4cefad8cDd5f490584929ab0bffa628b parentTag="SignupPages314318310fb14e5f880bB30691a5f62e" header={<SecondaryMarketingHeader46e8287a4bfb4421A3bdAdd5b7823e32 parentTag="Header487b8ff06565488882df11125c29fce5" title="Join Us" />} {...props} />
  );
}

// id: "bf094e87-9891-4718-9d43-654487499262"
// title: "Polytopia 2026 Schedule"
// type: :html
// key: "polytopia-2026-schedule"
// parent_id: nil
export function Polytopia2026ScheduleBf094e87989147189d43654487499262(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2026ScheduleBf094e87989147189d43654487499262 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="Header597719ea4fc9492cBc0395666caf81d8" parentTag={buildClassName("Header597719ea4fc9492cBc0395666caf81d8", parentTag)} subType="header_with_hero" className="public-header-with-hero secondary-page" contentSlug="polytopia-2026-sponsors-header-with-hero" as="header" {...props} />}
      <main>
        {props["main-content"] || <PageContentSimplified className="MainContent66f1cd583f714f72841d1ab5d051be67" parentTag={buildClassName("MainContent66f1cd583f714f72841d1ab5d051be67", parentTag)} contentSlug="polytopia-2026-schedule-main" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="FooterBc6d66770ac7463bA935Bfa4fb213407" {...props} />}
    </div>
  );
}

// id: "a4867a33-b561-450d-85a9-36f67e3845ab"
// title: "Polytopia 2026 Presenters"
// type: :html
// key: "polytopia-2026-presenters"
// parent_id: nil
export function Polytopia2026PresentersA4867a33B561450d85a936f67e3845ab(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2026PresentersA4867a33B561450d85a936f67e3845ab page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="Header1cd1523026134410A64d86765a0fc3e9" parentTag={buildClassName("Header1cd1523026134410A64d86765a0fc3e9", parentTag)} contentSlug="polytopia-2026-presenters-header-with-hero" subType="header_with_hero" as="header" className="public-header-with-hero secondary-page" {...props} />}
      <main>
        {props["intro"] || <ContentSnippet className="Intro95e743a8Acec4d29881a8e5ae3f0995e" parentTag={buildClassName("Intro95e743a8Acec4d29881a8e5ae3f0995e", parentTag)} contentSlug="polytopia-2026-presenters-intro-text" className="intro-text" {...props} />}
        {props["cards"] || <MarketingCards className="CardsDfeae2f2573645ca8f3947425390e9e8" parentTag={buildClassName("CardsDfeae2f2573645ca8f3947425390e9e8", parentTag)} postSlug="polytopia-2026-presenters-cards" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="FooterF85d344cFc5a4722B1b1Cfec30d7810e" {...props} />}
    </div>
  );
}

// id: "a205bb2d-69d3-4114-8f06-d8094dda6655"
// title: "Member Pages"
// type: :html
// key: "member-pages"
// parent_id: nil
export function MemberPagesA205bb2d69d341148f06D8094dda6655(props: any) {
  const SecondaryNavigation = AppStore.presets["SecondaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MemberPagesA205bb2d69d341148f06D8094dda6655 gf-page-layout`}>
      {props["header"] || <MembersAreaHeaderF9d2c204Ca514b8bA2a4A44a7305a5fd parentTag="Header962c7d0b1d5c41f8Bf56Fa72373b342d" {...props} />}
      {props["secondary-nav"] || <SecondaryNavigation className="SecondaryNavC57ee9929a8d4859Bfbf1361c65f0e92" parentTag={buildClassName("SecondaryNavC57ee9929a8d4859Bfbf1361c65f0e92", parentTag)} {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="FooterFa77a35fA4d644a5A4065d41a36addf1" {...props} />}
    </div>
  );
}

// id: "0ca15a34-ab6e-4dc0-9e8d-8d582e9365e6"
// title: "Resources Page"
// type: :reference
// key: "resources-page"
// parent_id: nil
export function ResourcesPage0ca15a34Ab6e4dc09e8d8d582e9365e6(props: any) {
  return (
    <SecondaryPage4cefad8cDd5f490584929ab0bffa628b parentTag="ResourcesPage0ca15a34Ab6e4dc09e8d8d582e9365e6" header={<SecondaryMarketingHeader46e8287a4bfb4421A3bdAdd5b7823e32 parentTag="Header5377d850007f45aaB5e15e86f61be8ab" title="Resources" />} {...props} />
  );
}

// id: "23f825d3-eb90-4c2c-aad8-5622b537408d"
// title: ""
// type: :html
// key: "logo"
// parent_id: "6d28a864-391b-46b0-8e2e-ce2784eb6f17"
export function Logo23f825d3Eb904c2cAad85622b537408d(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3.amazonaws.com/spp/images/spp-logo-white.svg" alt="SPP logo" className={`${parentTag || ""} Logo23f825d3Eb904c2cAad85622b537408d logo`} />
  );
}

// id: "b2e1337d-a9e8-43cc-99b9-1aaab7960131"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "27ebb718-2df7-42ba-a258-1b7815e0e4ef"
export function FooterB2e1337dA9e843cc99b91aaab7960131(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="FooterB2e1337dA9e843cc99b91aaab7960131" {...props} />
  );
}

// id: "dcc18c6b-0e1c-4998-b76f-0fd4ea742e89"
// title: ""
// type: :text
// key: "title"
// parent_id: "46e8287a-4bfb-4421-a3bd-add5b7823e32"
export const TitleDcc18c6b0e1c4998B76f0fd4ea742e89 = "Secondary Marketing Title 1";

// id: "e702a3b2-54f1-4a0b-aa3c-c07e89d2fa73"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "161ec63b-1b36-486e-b50e-3fce09959017"
export function SponsorsE702a3b254f14a0bAa3cC07e89d2fa73(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="SponsorsE702a3b254f14a0bAa3cC07e89d2fa73" parentTag={buildClassName("SponsorsE702a3b254f14a0bAa3cC07e89d2fa73", parentTag)} {...props} />
  );
}

// id: "26984018-0df9-4a1f-b9e2-bb3426a5ee92"
// title: ""
// type: :reference
// key: "header"
// parent_id: "4cefad8c-dd5f-4905-8492-9ab0bffa628b"
export function Header269840180df94a1fB9e2Bb3426a5ee92(props: any) {
  return (
    <SecondaryMarketingHeader46e8287a4bfb4421A3bdAdd5b7823e32 parentTag="Header269840180df94a1fB9e2Bb3426a5ee92" title="Secondary Page" {...props} />
  );
}

// id: "7c7b8063-299d-4c53-bc2d-7bfd59013bac"
// title: ""
// type: :text
// key: "subType"
// parent_id: "03159174-a34f-4b94-a8dc-70fec2708368"
export const SubType7c7b8063299d4c53Bc2d7bfd59013bac = "header_with_hero";

// id: "044e6bc5-a486-4148-b9c8-599c081e7782"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "09504972-f202-4eaf-8d14-2331563059cc"
export const ContentSlug044e6bc5A4864148B9c8599c081e7782 = "polytopia-2025-sponsors-intro";

// id: "85c6ff7c-fc7f-4207-9e00-5b4a8804ac1f"
// title: ""
// type: :text
// key: "title"
// parent_id: "8f4a57b7-7c80-4120-91a1-21e9c1c38d7b"
export const Title85c6ff7cFc7f42079e005b4a8804ac1f = "Public Events";

// id: "486f46ff-e321-4c9c-b00a-ff84f4929b0d"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "f6420103-9f71-4cc8-8193-b7f48567090f"
export const ContentSlug486f46ffE3214c9cB00aFf84f4929b0d = "polytopia-2025-schedule-header-with-hero";

// id: "146c9c90-de40-45ff-87e4-513bd79fe176"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "f87a6608-a300-475c-8ae7-df08bbbc1158"
export const ContentSlug146c9c90De4045ff87e4513bd79fe176 = "polytopia-2026-header-with-hero";

// id: "7d24c00a-3e51-45c3-8501-2d4fd3079d1f"
// title: "Polytopia 2026 Handouts"
// type: :html
// key: "polytopia-2026-handouts"
// parent_id: nil
export function Polytopia2026Handouts7d24c00a3e5145c385012d4fd3079d1f(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2026Handouts7d24c00a3e5145c385012d4fd3079d1f page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="Header03159174A34f4b94A8dc70fec2708368" parentTag={buildClassName("Header03159174A34f4b94A8dc70fec2708368", parentTag)} subType="header_with_hero" contentSlug="polytopia-2026-handouts-header-with-hero" className="public-header-with-hero secondary-page" as="header" {...props} />}
      <main>
        {props["main-content"] || <PageContentSimplified className="MainContent1e601535765c49f18ebe565b8e4395f2" parentTag={buildClassName("MainContent1e601535765c49f18ebe565b8e4395f2", parentTag)} contentSlug="polytopia-2026-handouts-main" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer57ac424f10d44853Ad47C3ae22149f16" {...props} />}
    </div>
  );
}

// id: "67f6f45b-0883-4561-b89e-9c3cc608e0df"
// title: "Polytopia 2025 Workshops"
// type: :html
// key: "polytopia-2025-workshops"
// parent_id: nil
export function Polytopia2025Workshops67f6f45b08834561B89e9c3cc608e0df(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2025Workshops67f6f45b08834561B89e9c3cc608e0df page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="Header2892b866Ab8c47d896747dd8ad0c3d36" parentTag={buildClassName("Header2892b866Ab8c47d896747dd8ad0c3d36", parentTag)} subType="header_with_hero" className="public-header-with-hero secondary-page" as="header" contentSlug="polytopia-2025-workshops-header-with-hero" {...props} />}
      <main>
        {props["main-content"] || <PageContentSimplified className="MainContent902d49a9867d469197a36c227cb214db" parentTag={buildClassName("MainContent902d49a9867d469197a36c227cb214db", parentTag)} contentSlug="polytopia-2025-workshops-content" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer16c0ad24C654436dAed26658a7d90cc8" {...props} />}
    </div>
  );
}

// id: "5e4b61e6-136b-4c32-9be8-90b33fbc406b"
// title: "Marketing Cards Body"
// type: :html
// key: "marketing-body"
// parent_id: nil
export function MarketingBody5e4b61e6136b4c329be890b33fbc406b(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MarketingBody5e4b61e6136b4c329be890b33fbc406b page-body`}>
      {props["marketingCards"] || <MarketingCardsB5bdf19784c64598Ba9aE3cca29275dd parentTag="MarketingCards5d3c23187ce544249793Be7d03075b28" postSlug="home-page-posts2" {...props} />}
    </div>
  );
}

// id: "cba51883-68d3-4072-880a-aafa4c988982"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "bf094e87-9891-4718-9d43-654487499262"
export function SponsorsCba5188368d34072880aAafa4c988982(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="SponsorsCba5188368d34072880aAafa4c988982" parentTag={buildClassName("SponsorsCba5188368d34072880aAafa4c988982", parentTag)} {...props} />
  );
}

// id: "f87a6608-a300-475c-8ae7-df08bbbc1158"
// title: "Header"
// type: :gf_preset
// key: "header"
// parent_id: "df06157b-080e-4a94-9534-d6fd5e4e141c"
export function HeaderF87a6608A300475c8ae7Df08bbbc1158(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderF87a6608A300475c8ae7Df08bbbc1158" parentTag={buildClassName("HeaderF87a6608A300475c8ae7Df08bbbc1158", parentTag)} contentSlug="polytopia-2026-header-with-hero" className="public-header-with-hero secondary-page" subType="header_with_hero" as="header" {...props} />
  );
}

// id: "b53e0845-f257-4f93-a6fd-08db6ab675ac"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "23d20992-5bf2-48b3-9101-af66f3618c42"
export function NavigationB53e0845F2574f93A6fd08db6ab675ac(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="NavigationB53e0845F2574f93A6fd08db6ab675ac" parentTag={buildClassName("NavigationB53e0845F2574f93A6fd08db6ab675ac", parentTag)} navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "539b6810-145a-4403-bb2a-849d0a68fb45"
// title: ""
// type: :gf_preset
// key: "hero"
// parent_id: "13343270-aaef-4ba9-a004-8f74b7d0702d"
export function Hero539b6810145a4403Bb2a849d0a68fb45(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Hero className="Hero539b6810145a4403Bb2a849d0a68fb45" parentTag={buildClassName("Hero539b6810145a4403Bb2a849d0a68fb45", parentTag)} postSlug="home-hero" {...props} />
  );
}

// id: "c57ee992-9a8d-4859-bfbf-1361c65f0e92"
// title: ""
// type: :gf_preset
// key: "secondary-nav"
// parent_id: "a205bb2d-69d3-4114-8f06-d8094dda6655"
export function SecondaryNavC57ee9929a8d4859Bfbf1361c65f0e92(props: any) {
  const SecondaryNavigation = AppStore.presets["SecondaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <SecondaryNavigation className="SecondaryNavC57ee9929a8d4859Bfbf1361c65f0e92" parentTag={buildClassName("SecondaryNavC57ee9929a8d4859Bfbf1361c65f0e92", parentTag)} {...props} />
  );
}

// id: "93156f4b-0705-43fb-abf2-ac2afb0e2aab"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "516d7bfb-b25b-4173-a1a6-6fdeb815cdb4"
export const PostSlug93156f4b070543fbAbf2Ac2afb0e2aab = "polytopia-2024";

// id: "8338ddb9-f60b-4327-9f86-f1f01d6e3daa"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "f10eadf8-147f-4cff-9240-85839b329cd8"
export const NavMenuSlug8338ddb9F60b43279f86F1f01d6e3daa = "footer-nav";

// id: "14ba31f6-5fc9-4a79-bd72-9ca153e6a128"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "902d49a9-867d-4691-97a3-6c227cb214db"
export const ContentSlug14ba31f65fc94a79Bd729ca153e6a128 = "polytopia-2025-workshops-content";

// id: "020b7917-4532-4038-88d5-bab5474c15f4"
// title: ""
// type: :text
// key: "href"
// parent_id: "791e01b1-0502-4345-9583-7d0461dc458a"
export const Href020b79174532403888d5Bab5474c15f4 = "/join";

// id: "ef47152b-0f14-4031-80c4-a7490af14808"
// title: ""
// type: :text
// key: "className"
// parent_id: "a08faa13-7d9c-4bbf-9352-ff58a8439fc3"
export const ClassNameEf47152b0f14403180c4A7490af14808 = "public-header-with-hero secondary-page";

// id: "64a547e5-2697-4305-89f9-d0aef2a273c7"
// title: "Polytopia 2026 Sponsors"
// type: :html
// key: "polytopia-2026-sponsors"
// parent_id: nil
export function Polytopia2026Sponsors64a547e52697430589f9D0aef2a273c7(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2026Sponsors64a547e52697430589f9D0aef2a273c7 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="Header7acf5ec741ce43508e6bFefa72e3f7c3" parentTag={buildClassName("Header7acf5ec741ce43508e6bFefa72e3f7c3", parentTag)} className="public-header-with-hero secondary-page" contentSlug="polytopia-2025-sponsors-header-with-hero" subType="header_with_hero" as="header" {...props} />}
      <main>
        {props["intro"] || <ContentSnippet className="IntroA1b4a8cdB6174450A3a52fb4e8795a41" parentTag={buildClassName("IntroA1b4a8cdB6174450A3a52fb4e8795a41", parentTag)} contentSlug="polytopia-2026-sponsors-intro" {...props} />}
        {props["cards"] || <MarketingCards className="CardsB40f2d0a99d04cd2A2558f76555a3c20" parentTag={buildClassName("CardsB40f2d0a99d04cd2A2558f76555a3c20", parentTag)} postSlug="polytopia-2026-sponsors-cards" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="FooterB627bba7D38149a0A1a7C1152e4938f6" {...props} />}
    </div>
  );
}

// id: "51196b24-76d2-4b11-bfe5-f3accc666a93"
// title: "Message Pages"
// type: :html
// key: "message-pages"
// parent_id: nil
export function MessagePages51196b2476d24b11Bfe5F3accc666a93(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MessagePages51196b2476d24b11Bfe5F3accc666a93 gf-page-layout`}>
      {props["header"] || <MembersAreaHeaderF9d2c204Ca514b8bA2a4A44a7305a5fd parentTag="Header501fc3bcCa974cde91f7Cbd4d7ba33e6" {...props} />}
      {props.children}
    </div>
  );
}

// id: "df06157b-080e-4a94-9534-d6fd5e4e141c"
// title: "Polytopia 2026"
// type: :html
// key: "polytopia-2026"
// parent_id: nil
export function Polytopia2026Df06157b080e4a949534D6fd5e4e141c(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2026Df06157b080e4a949534D6fd5e4e141c page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="HeaderF87a6608A300475c8ae7Df08bbbc1158" parentTag={buildClassName("HeaderF87a6608A300475c8ae7Df08bbbc1158", parentTag)} contentSlug="polytopia-2026-header-with-hero" className="public-header-with-hero secondary-page" subType="header_with_hero" as="header" {...props} />}
      <main>
        {props["cards"] || <MarketingCards className="Cards6fb449f346a34f67A737C659e158928a" parentTag={buildClassName("Cards6fb449f346a34f67A737C659e158928a", parentTag)} postSlug="polytopia-2026-cards" {...props} />}
        {props["sponsors"] || <ContentSnippet className="SponsorsAc89e108885e4434B26429668083e15a" parentTag={buildClassName("SponsorsAc89e108885e4434B26429668083e15a", parentTag)} contentSlug="polytopia-2026-sponsors" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="FooterA18ad67e27934c639a5bE5fc84c36d63" {...props} />}
    </div>
  );
}

// id: "12b90316-20c9-4556-8f3f-2d95c563c0d0"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "b5bdf197-84c6-4598-ba9a-e3cca29275dd"
export const PostSlug12b9031620c945568f3f2d95c563c0d0 = "home-page-posts2";

// id: "1cd15230-2613-4410-a64d-86765a0fc3e9"
// title: "Header"
// type: :gf_preset
// key: "header"
// parent_id: "a4867a33-b561-450d-85a9-36f67e3845ab"
export function Header1cd1523026134410A64d86765a0fc3e9(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header1cd1523026134410A64d86765a0fc3e9" parentTag={buildClassName("Header1cd1523026134410A64d86765a0fc3e9", parentTag)} contentSlug="polytopia-2026-presenters-header-with-hero" subType="header_with_hero" as="header" className="public-header-with-hero secondary-page" {...props} />
  );
}

// id: "af40ecc3-6856-46f7-b38e-dfee76dd4b1c"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "b6c2307b-d681-4f14-a258-b20d9016e163"
export function NavigationAf40ecc3685646f7B38eDfee76dd4b1c(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="NavigationAf40ecc3685646f7B38eDfee76dd4b1c" parentTag={buildClassName("NavigationAf40ecc3685646f7B38eDfee76dd4b1c", parentTag)} navMenuSlug="marketing-primary-nav" className="navigation" {...props} />
  );
}

// id: "b9b7eae5-7d33-48a7-b4ed-c1c529a55440"
// title: ""
// type: :reference
// key: "header"
// parent_id: "3538a127-aa33-4e05-90c1-d5d4f38c6467"
export function HeaderB9b7eae57d3348a7B4edC1c529a55440(props: any) {
  return (
    <SecondaryMarketingHeader46e8287a4bfb4421A3bdAdd5b7823e32 parentTag="HeaderB9b7eae57d3348a7B4edC1c529a55440" title="About Us" {...props} />
  );
}

// id: "5a1d5132-88c7-48df-8e1f-f04eaea92173"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone I9XQT7FHAZPJGAC15 Clone YBYEQWBTJ7M1RURES Clone 9QERD06Z1IRV6P2WO Clone RA2IOSI5WU9MZT94L Clone X60TRD0XRW2DZ77ZB"
// type: :reference
// key: "footer"
// parent_id: "1018f660-f5d1-490e-a486-2d1112478006"
export function Footer5a1d513288c748df8e1fF04eaea92173(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer5a1d513288c748df8e1fF04eaea92173" {...props} />
  );
}

// id: "7a179810-387f-412a-89da-3596bc3634bd"
// title: ""
// type: :text
// key: "className"
// parent_id: "7acf5ec7-41ce-4350-8e6b-fefa72e3f7c3"
export const ClassName7a179810387f412a89da3596bc3634bd = "public-header-with-hero secondary-page";

// id: "5da41394-a49f-441f-a25e-ffe423e0a009"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "f1ead838-8e7d-4d56-9957-87255a036308"
export const ContentSlug5da41394A49f441fA25eFfe423e0a009 = "home-page-quote";

// id: "42121220-ab34-4631-b6da-f6a965dc8709"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "a1b4a8cd-b617-4450-a3a5-2fb4e8795a41"
export const ContentSlug42121220Ab344631B6daF6a965dc8709 = "polytopia-2026-sponsors-intro";

// id: "c97f69a3-64b3-43d5-956c-9becc05b7e1c"
// title: ""
// type: :reference
// key: "label"
// parent_id: "163ca03a-ae8e-434b-9112-3c65cee9700d"
export function LabelC97f69a364b343d5956c9becc05b7e1c(props: any) {
  return (
    <DefaultLogo61ee95b52f514b33A182C65924ce10ad parentTag="LabelC97f69a364b343d5956c9becc05b7e1c" {...props} />
  );
}

// id: "fc68199a-9b7d-4771-a05b-38b0670f42a7"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "dfeae2f2-5736-45ca-8f39-47425390e9e8"
export const PostSlugFc68199a9b7d4771A05b38b0670f42a7 = "polytopia-2026-presenters-cards";

// id: "6d28a864-391b-46b0-8e2e-ce2784eb6f17"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter6d28a864391b46b08e2eCe2784eb6f17(props: any) {
  const SocialLinks = AppStore.presets["SocialLinks"];
  const Navigation = AppStore.presets["Navigation"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 footer`}>
      {props["social-links"] || <SocialLinks className="SocialLinks9ff797c3B5744e40Bb51B9b6755a103a" parentTag={buildClassName("SocialLinks9ff797c3B5744e40Bb51B9b6755a103a", parentTag)} postSlug="footer-social-links" {...props} />}
      {props["links"] || <Navigation className="LinksF10eadf8147f4cff924085839b329cd8" parentTag={buildClassName("LinksF10eadf8147f4cff924085839b329cd8", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo23f825d3Eb904c2cAad85622b537408d />}
      </div>
      {props["copyright"] || <GroupCopyright className="CopyrightB1fba87dF7ed4567Aa6d596b27ee9ac7" parentTag={buildClassName("CopyrightB1fba87dF7ed4567Aa6d596b27ee9ac7", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow1c69407b3fdf4b3995e74c9e3b125231" parentTag={buildClassName("Groupflow1c69407b3fdf4b3995e74c9e3b125231", parentTag)} {...props} />}
    </footer>
  );
}

// id: "5d1635a4-4895-46fa-a462-10994027b300"
// title: "Default Header Reference"
// type: :reference
// key: "default-header"
// parent_id: nil
export function DefaultHeader5d1635a4489546faA46210994027b300(props: any) {
  return (
    <ShortHeader23d209925bf248b39101Af66f3618c42 parentTag="DefaultHeader5d1635a4489546faA46210994027b300" title navMenuSlug="marketing-primary-nav" {...props} />
  );
}

// id: "1018f660-f5d1-490e-a486-2d1112478006"
// title: "Polytopia 2025 Handouts"
// type: :html
// key: "polytopia-2025-handouts"
// parent_id: nil
export function Polytopia2025Handouts1018f660F5d1490eA4862d1112478006(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2025Handouts1018f660F5d1490eA4862d1112478006 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="HeaderDdb7077fA7654a1d8bb0Da405d0a90a8" parentTag={buildClassName("HeaderDdb7077fA7654a1d8bb0Da405d0a90a8", parentTag)} subType="header_with_hero" className="public-header-with-hero secondary-page" as="header" contentSlug="polytopia-2025-handouts-header-with-hero" {...props} />}
      <main>
        {props["main-content"] || <PageContentSimplified className="MainContent501ee711Ff3f45a5A7a108d57a08acd4" parentTag={buildClassName("MainContent501ee711Ff3f45a5A7a108d57a08acd4", parentTag)} contentSlug="polytopia-2025-handouts-main" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer5a1d513288c748df8e1fF04eaea92173" {...props} />}
    </div>
  );
}

// id: "168afb76-74c8-4d6e-846f-0b3a8e7e88de"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "b93fa53c-0235-4c33-a2a7-4b3bfe6b8464"
export function Sponsors168afb7674c84d6e846f0b3a8e7e88de(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="Sponsors168afb7674c84d6e846f0b3a8e7e88de" parentTag={buildClassName("Sponsors168afb7674c84d6e846f0b3a8e7e88de", parentTag)} {...props} />
  );
}

// id: "64031602-878b-4189-b772-475df5163551"
// title: ""
// type: :reference
// key: "header"
// parent_id: "67429ef0-5c42-457a-a9ae-d89ea03fd5ea"
export function Header64031602878b4189B772475df5163551(props: any) {
  return (
    <SecondaryMarketingHeader46e8287a4bfb4421A3bdAdd5b7823e32 parentTag="Header64031602878b4189B772475df5163551" title="Polytopia 2024 Workshops" {...props} />
  );
}

// id: "82133fc0-79a7-4da8-89eb-43562ccb2e78"
// title: ""
// type: :text
// key: "backgroundImage"
// parent_id: "13343270-aaef-4ba9-a004-8f74b7d0702d"
export const BackgroundImage82133fc079a74da889eb43562ccb2e78 = "https://mp1md-pub.s3.amazonaws.com/spp/images/page-background-photo.jpg";

// id: "ca7acaeb-5401-4709-bc40-e751735ca206"
// title: ""
// type: :reference
// key: "body"
// parent_id: "27ebb718-2df7-42ba-a258-1b7815e0e4ef"
export function BodyCa7acaeb54014709Bc40E751735ca206(props: any) {
  return (
    <MarketingBody5e4b61e6136b4c329be890b33fbc406b parentTag="BodyCa7acaeb54014709Bc40E751735ca206" {...props} />
  );
}

// id: "14a06d70-b335-433c-8786-8ff6c23dbb99"
// title: ""
// type: :gf_preset
// key: "welcome-back"
// parent_id: "27ebb718-2df7-42ba-a258-1b7815e0e4ef"
export function WelcomeBack14a06d70B335433c87868ff6c23dbb99(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <WelcomeBackPopUp className="WelcomeBack14a06d70B335433c87868ff6c23dbb99" parentTag={buildClassName("WelcomeBack14a06d70B335433c87868ff6c23dbb99", parentTag)} {...props} />
  );
}

// id: "46348aae-0aa9-4aee-8328-affac296bcdc"
// title: ""
// type: :text
// key: "subType"
// parent_id: "9761af07-bc2d-4c8d-afc6-1172ab1207c8"
export const SubType46348aae0aa94aee8328Affac296bcdc = "header_with_hero";

// id: "91cc0c80-0917-4359-8ac8-b74c632591d3"
// title: ""
// type: :text
// key: "title"
// parent_id: "64031602-878b-4189-b772-475df5163551"
export const Title91cc0c80091743598ac8B74c632591d3 = "Polytopia 2024 Workshops";

// id: "14bd94dd-b68c-4c8e-9f8e-bea7ee3bb417"
// title: ""
// type: :text
// key: "subType"
// parent_id: "2892b866-ab8c-47d8-9674-7dd8ad0c3d36"
export const SubType14bd94ddB68c4c8e9f8eBea7ee3bb417 = "header_with_hero";

// id: "fc34f6d5-ef65-443e-900f-36992e4b26b9"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "66f1cd58-3f71-4f72-841d-1ab5d051be67"
export const ContentSlugFc34f6d5Ef65443e900f36992e4b26b9 = "polytopia-2026-schedule-main";

// id: "07bead84-fd8e-4052-8020-d283a36d2f84"
// title: ""
// type: :text
// key: "className"
// parent_id: "be9a936f-f4ef-404f-b5fe-da9b95a18828"
export const ClassName07bead84Fd8e40528020D283a36d2f84 = "public-header-with-hero secondary-page";

// id: "61ee95b5-2f51-4b33-a182-c65924ce10ad"
// title: "Logo"
// type: :html
// key: "default-logo"
// parent_id: nil
export function DefaultLogo61ee95b52f514b33A182C65924ce10ad(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3.us-west-2.amazonaws.com/spp-logo.svg" className={`${parentTag || ""} DefaultLogo61ee95b52f514b33A182C65924ce10ad logo`} alt="logo" />
  );
}

// id: "d85a5202-4c28-4d7f-8df2-671b4d39473a"
// title: "Secondary Marketing Hero"
// type: :html
// key: "secondary-marketing-hero"
// parent_id: nil
export function SecondaryMarketingHeroD85a52024c284d7f8df2671b4d39473a(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeroD85a52024c284d7f8df2671b4d39473a hero`}>
      <div className="title">
        {props["title"] || Title1e33bc02924b454e9974Eb8dbe154fa6}
      </div>
    </div>
  );
}

// id: "4d0bc7a0-2990-47a8-a2f3-4c341e885d57"
// title: "Admin Pages"
// type: :html
// key: "admin-pages"
// parent_id: nil
export function AdminPages4d0bc7a0299047a8A2f34c341e885d57(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AdminPages4d0bc7a0299047a8A2f34c341e885d57`}>
      {props.children}
    </div>
  );
}

// id: "767039e6-ef68-4393-b088-29c4047eed12"
// title: ""
// type: :text
// key: "imageUrl"
// parent_id: "61ee95b5-2f51-4b33-a182-c65924ce10ad"
export const ImageUrl767039e6Ef684393B08829c4047eed12 = "https://mp1md-pub.s3.us-west-2.amazonaws.com/spp-logo.svg";

// id: "d14c9e7f-5702-42d0-8256-d2c1aed5f858"
// title: "Members Header"
// type: :reference
// key: "header"
// parent_id: nil
export function HeaderD14c9e7f570242d08256D2c1aed5f858(props: any) {
  return (
    <MembersAreaHeaderF9d2c204Ca514b8bA2a4A44a7305a5fd parentTag="HeaderD14c9e7f570242d08256D2c1aed5f858" {...props} />
  );
}

// id: "77f22cd6-ae63-49b9-ae76-f1f1c696d4b5"
// title: "Polytopia 2025 Sponsors"
// type: :html
// key: "polytopia-2025-sponsors"
// parent_id: nil
export function Polytopia2025Sponsors77f22cd6Ae6349b9Ae76F1f1c696d4b5(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2025Sponsors77f22cd6Ae6349b9Ae76F1f1c696d4b5 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="Header9761af07Bc2d4c8dAfc61172ab1207c8" parentTag={buildClassName("Header9761af07Bc2d4c8dAfc61172ab1207c8", parentTag)} subType="header_with_hero" className="public-header-with-hero secondary-page" contentSlug="polytopia-2025-sponsors-header-with-hero" as="header" {...props} />}
      <main>
        {props["intro"] || <ContentSnippet className="Intro09504972F2024eaf8d142331563059cc" parentTag={buildClassName("Intro09504972F2024eaf8d142331563059cc", parentTag)} contentSlug="polytopia-2025-sponsors-intro" {...props} />}
        {props["cards"] || <MarketingCards className="Cards22c216b0214548999f101a141bf14483" parentTag={buildClassName("Cards22c216b0214548999f101a141bf14483", parentTag)} postSlug="polytopia-2025-sponsors" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer0ef54779Cb7649ccBf066b9d2d9af470" {...props} />}
    </div>
  );
}

// id: "962c7d0b-1d5c-41f8-bf56-fa72373b342d"
// title: ""
// type: :reference
// key: "header"
// parent_id: "a205bb2d-69d3-4114-8f06-d8094dda6655"
export function Header962c7d0b1d5c41f8Bf56Fa72373b342d(props: any) {
  return (
    <MembersAreaHeaderF9d2c204Ca514b8bA2a4A44a7305a5fd parentTag="Header962c7d0b1d5c41f8Bf56Fa72373b342d" {...props} />
  );
}

// id: "b1303089-895d-4c8d-ad6f-c4c9678d303d"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "a4867a33-b561-450d-85a9-36f67e3845ab"
export function SponsorsB1303089895d4c8dAd6fC4c9678d303d(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="SponsorsB1303089895d4c8dAd6fC4c9678d303d" parentTag={buildClassName("SponsorsB1303089895d4c8dAd6fC4c9678d303d", parentTag)} {...props} />
  );
}

// id: "bc6d6677-0ac7-463b-a935-bfa4fb213407"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone I9XQT7FHAZPJGAC15 Clone YBYEQWBTJ7M1RURES Clone 9QERD06Z1IRV6P2WO Clone RA2IOSI5WU9MZT94L Clone YUVGVZYF1SFIDD5MB"
// type: :reference
// key: "footer"
// parent_id: "bf094e87-9891-4718-9d43-654487499262"
export function FooterBc6d66770ac7463bA935Bfa4fb213407(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="FooterBc6d66770ac7463bA935Bfa4fb213407" {...props} />
  );
}

// id: "5071c4ad-d914-40a1-8a1f-22f710551a4b"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "3538a127-aa33-4e05-90c1-d5d4f38c6467"
export function Footer5071c4adD91440a18a1f22f710551a4b(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer5071c4adD91440a18a1f22f710551a4b" {...props} />
  );
}

// id: "a3c1651d-f463-4b35-9ce1-c094693dba72"
// title: ""
// type: :reference
// key: "header"
// parent_id: "a37c2102-173c-4d49-a14a-f3f10597a1f5"
export function HeaderA3c1651dF4634b359ce1C094693dba72(props: any) {
  return (
    <MembersAreaHeaderF9d2c204Ca514b8bA2a4A44a7305a5fd parentTag="HeaderA3c1651dF4634b359ce1C094693dba72" navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "e799950c-2884-4a63-9005-8d46cb3fc2a2"
// title: ""
// type: :text
// key: "subType"
// parent_id: "f6420103-9f71-4cc8-8193-b7f48567090f"
export const SubTypeE799950c28844a6390058d46cb3fc2a2 = "header_with_hero";

// id: "1c3dafa3-2853-42ab-b163-dbd287120263"
// title: ""
// type: :text
// key: "title"
// parent_id: "b9b7eae5-7d33-48a7-b4ed-c1c529a55440"
export const Title1c3dafa3285342abB163Dbd287120263 = "About Us";

// id: "f670aa59-4565-4394-a872-58c46e069dad"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "cae48e4a-d8ab-4484-afe9-7c2058b2e7e3"
export const PostSlugF670aa5945654394A87258c46e069dad = "polytopia-2025";

// id: "dfa12350-ea68-4634-8fb9-add07ab64450"
// title: ""
// type: :text
// key: "subType"
// parent_id: "ddb7077f-a765-4a1d-8bb0-da405d0a90a8"
export const SubTypeDfa12350Ea6846348fb9Add07ab64450 = "header_with_hero";

// id: "4c2bd480-22ba-4765-ba2f-54551cf2b1e6"
// title: ""
// type: :text
// key: "className"
// parent_id: "f87a6608-a300-475c-8ae7-df08bbbc1158"
export const ClassName4c2bd48022ba4765Ba2f54551cf2b1e6 = "public-header-with-hero secondary-page";

// id: "46e8287a-4bfb-4421-a3bd-add5b7823e32"
// title: "Secondary Marketing Header"
// type: :html
// key: "secondary-marketing-header"
// parent_id: nil
export function SecondaryMarketingHeader46e8287a4bfb4421A3bdAdd5b7823e32(props: any) {
  const { parentTag, ...rest } = props;
  props = { title: "Secondary Marketing Title 1", ...rest };
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeader46e8287a4bfb4421A3bdAdd5b7823e32 site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopB6c2307bD6814f14A258B20d9016e163 parentTag="HeaderTop4df8f5a81a49421e9632Ef2ed7ab1247" {...props} />}
      </div>
      {props["hero"] || <SecondaryMarketingHeroD85a52024c284d7f8df2671b4d39473a parentTag="Hero551e039750c749c2B65b01c58185db98" title="Secondary Marketing Title 2" {...props} />}
    </div>
  );
}

// id: "cdf4c839-0b3f-4051-a040-be65b6e59fa0"
// title: "Join Us Page"
// type: :reference
// key: "join-us-page"
// parent_id: nil
export function JoinUsPageCdf4c8390b3f4051A040Be65b6e59fa0(props: any) {
  return (
    <SecondaryPage4cefad8cDd5f490584929ab0bffa628b parentTag="JoinUsPageCdf4c8390b3f4051A040Be65b6e59fa0" header={<SecondaryMarketingHeader46e8287a4bfb4421A3bdAdd5b7823e32 parentTag="HeaderCce9cc5987a64a3283393b93d7e0c2f5" title="Join Us" />} {...props} />
  );
}

// id: "dfeae2f2-5736-45ca-8f39-47425390e9e8"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "a4867a33-b561-450d-85a9-36f67e3845ab"
export function CardsDfeae2f2573645ca8f3947425390e9e8(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="CardsDfeae2f2573645ca8f3947425390e9e8" parentTag={buildClassName("CardsDfeae2f2573645ca8f3947425390e9e8", parentTag)} postSlug="polytopia-2026-presenters-cards" {...props} />
  );
}

// id: "5d3c2318-7ce5-4424-9793-be7d03075b28"
// title: ""
// type: :reference
// key: "marketingCards"
// parent_id: "5e4b61e6-136b-4c32-9be8-90b33fbc406b"
export function MarketingCards5d3c23187ce544249793Be7d03075b28(props: any) {
  return (
    <MarketingCardsB5bdf19784c64598Ba9aE3cca29275dd parentTag="MarketingCards5d3c23187ce544249793Be7d03075b28" postSlug="home-page-posts2" {...props} />
  );
}

// id: "1e601535-765c-49f1-8ebe-565b8e4395f2"
// title: ""
// type: :gf_preset
// key: "main-content"
// parent_id: "7d24c00a-3e51-45c3-8501-2d4fd3079d1f"
export function MainContent1e601535765c49f18ebe565b8e4395f2(props: any) {
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageContentSimplified className="MainContent1e601535765c49f18ebe565b8e4395f2" parentTag={buildClassName("MainContent1e601535765c49f18ebe565b8e4395f2", parentTag)} contentSlug="polytopia-2026-handouts-main" {...props} />
  );
}

// id: "ac89e108-885e-4434-b264-29668083e15a"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "df06157b-080e-4a94-9534-d6fd5e4e141c"
export function SponsorsAc89e108885e4434B26429668083e15a(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="SponsorsAc89e108885e4434B26429668083e15a" parentTag={buildClassName("SponsorsAc89e108885e4434B26429668083e15a", parentTag)} contentSlug="polytopia-2026-sponsors" {...props} />
  );
}

// id: "09504972-f202-4eaf-8d14-2331563059cc"
// title: ""
// type: :gf_preset
// key: "intro"
// parent_id: "77f22cd6-ae63-49b9-ae76-f1f1c696d4b5"
export function Intro09504972F2024eaf8d142331563059cc(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="Intro09504972F2024eaf8d142331563059cc" parentTag={buildClassName("Intro09504972F2024eaf8d142331563059cc", parentTag)} contentSlug="polytopia-2025-sponsors-intro" {...props} />
  );
}

// id: "4df8f5a8-1a49-421e-9632-ef2ed7ab1247"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "46e8287a-4bfb-4421-a3bd-add5b7823e32"
export function HeaderTop4df8f5a81a49421e9632Ef2ed7ab1247(props: any) {
  return (
    <DefaultHeaderTopB6c2307bD6814f14A258B20d9016e163 parentTag="HeaderTop4df8f5a81a49421e9632Ef2ed7ab1247" {...props} />
  );
}

// id: "378f4377-8e52-4570-a362-cbb5b4559640"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "9ff797c3-b574-4e40-bb51-b9b6755a103a"
export const PostSlug378f43778e524570A362Cbb5b4559640 = "footer-social-links";

// id: "af2f18c4-bd74-4e6f-a258-8fd09bdff3b2"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "524ed796-02b9-458f-bb09-ee30af38e811"
export const ContentSlugAf2f18c4Bd744e6fA2588fd09bdff3b2 = "polytopia-2026-workshops-content";

// id: "3bbc3f42-efab-4fd0-ac11-1e6aac5caac1"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "03159174-a34f-4b94-a8dc-70fec2708368"
export const ContentSlug3bbc3f42Efab4fd0Ac111e6aac5caac1 = "polytopia-2026-handouts-header-with-hero";

// id: "412551ad-3f17-45a0-b015-d88124cacaa7"
// title: ""
// type: :text
// key: "title"
// parent_id: "baef190d-6110-483b-a204-8916d38c11d3"
export const Title412551ad3f1745a0B015D88124cacaa7 = "Polytopia 2025";

// id: "b0faedd0-8b8c-4533-97a5-14dd9102962f"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "7acf5ec7-41ce-4350-8e6b-fefa72e3f7c3"
export const ContentSlugB0faedd08b8c453397a514dd9102962f = "polytopia-2025-sponsors-header-with-hero";

// id: "4cefad8c-dd5f-4905-8492-9ab0bffa628b"
// title: "Secondary Page"
// type: :html
// key: "secondary-page"
// parent_id: nil
export function SecondaryPage4cefad8cDd5f490584929ab0bffa628b(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryPage4cefad8cDd5f490584929ab0bffa628b gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeader46e8287a4bfb4421A3bdAdd5b7823e32 parentTag="Header269840180df94a1fB9e2Bb3426a5ee92" title="Secondary Page" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer623956c8733d48149568C62575c38f65" {...props} />}
    </div>
  );
}

// id: "5e4082e2-4d05-474c-bc95-fa01c3a2d009"
// title: "Title - Leveling"
// type: :text
// key: "title"
// parent_id: nil
export const Title5e4082e24d05474cBc95Fa01c3a2d009 = "Leveling";

// id: "16c0ad24-c654-436d-aed2-6658a7d90cc8"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone I9XQT7FHAZPJGAC15 Clone YBYEQWBTJ7M1RURES Clone 9QERD06Z1IRV6P2WO"
// type: :reference
// key: "footer"
// parent_id: "67f6f45b-0883-4561-b89e-9c3cc608e0df"
export function Footer16c0ad24C654436dAed26658a7d90cc8(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer16c0ad24C654436dAed26658a7d90cc8" {...props} />
  );
}

// id: "7b809bf6-fadd-48e1-93cd-0f7b523ff426"
// title: ""
// type: :text
// key: "backgroundImage"
// parent_id: "23d20992-5bf2-48b3-9101-af66f3618c42"
export const BackgroundImage7b809bf6Fadd48e193cd0f7b523ff426 = "https://mp1md-pub.s3.amazonaws.com/orgs/sample/city-background.jpg";

// id: "501ee711-ff3f-45a5-a7a1-08d57a08acd4"
// title: ""
// type: :gf_preset
// key: "main-content"
// parent_id: "1018f660-f5d1-490e-a486-2d1112478006"
export function MainContent501ee711Ff3f45a5A7a108d57a08acd4(props: any) {
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageContentSimplified className="MainContent501ee711Ff3f45a5A7a108d57a08acd4" parentTag={buildClassName("MainContent501ee711Ff3f45a5A7a108d57a08acd4", parentTag)} contentSlug="polytopia-2025-handouts-main" {...props} />
  );
}

// id: "baef190d-6110-483b-a204-8916d38c11d3"
// title: "Header Clone SiJc8owDIOQgqYh"
// type: :gf_preset
// key: "header"
// parent_id: "106561f4-6b13-4d2e-93b8-980dbecda65c"
export function HeaderBaef190d6110483bA2048916d38c11d3(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderBaef190d6110483bA2048916d38c11d3" parentTag={buildClassName("HeaderBaef190d6110483bA2048916d38c11d3", parentTag)} title="Polytopia 2025" subType="header_with_hero" contentSlug="polytopia-2025-header-with-hero" className="public-header-with-hero secondary-page" as="header" {...props} />
  );
}

// id: "5ec7c6f3-59ad-4407-9daa-22ac0d484146"
// title: ""
// type: :gf_preset
// key: "main-content"
// parent_id: "96c94154-3a23-47ee-a633-3f74c461ed62"
export function MainContent5ec7c6f359ad44079daa22ac0d484146(props: any) {
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageContentSimplified className="MainContent5ec7c6f359ad44079daa22ac0d484146" parentTag={buildClassName("MainContent5ec7c6f359ad44079daa22ac0d484146", parentTag)} contentSlug="polytopia-2025-schedule-main" {...props} />
  );
}

// id: "b40f2d0a-99d0-4cd2-a255-8f76555a3c20"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "64a547e5-2697-4305-89f9-d0aef2a273c7"
export function CardsB40f2d0a99d04cd2A2558f76555a3c20(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="CardsB40f2d0a99d04cd2A2558f76555a3c20" parentTag={buildClassName("CardsB40f2d0a99d04cd2A2558f76555a3c20", parentTag)} postSlug="polytopia-2026-sponsors-cards" {...props} />
  );
}

// id: "92bf3bf9-4d9a-4ede-9271-ae6af31aec49"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "b53e0845-f257-4f93-a6fd-08db6ab675ac"
export const NavMenuSlug92bf3bf94d9a4ede9271Ae6af31aec49 = "members-primary-nav";

// id: "f7aee0fa-ff7c-491e-84b2-2c8bebf3bd12"
// title: ""
// type: :text
// key: "className"
// parent_id: "03159174-a34f-4b94-a8dc-70fec2708368"
export const ClassNameF7aee0faFf7c491e84b22c8bebf3bd12 = "public-header-with-hero secondary-page";

// id: "4df2d428-000a-4b85-a515-4e46658ab12f"
// title: ""
// type: :text
// key: "title"
// parent_id: "a75825ab-16ea-4b46-8759-44fd1e10c499"
export const Title4df2d428000a4b85A5154e46658ab12f = "Polytopia 2024";

// id: "e83ce1e2-3424-498d-8646-d4c3fa14a85a"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "a08faa13-7d9c-4bbf-9352-ff58a8439fc3"
export const ContentSlugE83ce1e23424498d8646D4c3fa14a85a = "polytopia-2026-workshops-header-with-hero";

// id: "b0259339-ab0e-4dad-bd7e-4b5862239688"
// title: ""
// type: :text
// key: "as"
// parent_id: "f6420103-9f71-4cc8-8193-b7f48567090f"
export const AsB0259339Ab0e4dadBd7e4b5862239688 = "header";

// id: "23d20992-5bf2-48b3-9101-af66f3618c42"
// title: "Short Header"
// type: :html
// key: "short-header"
// parent_id: nil
export function ShortHeader23d209925bf248b39101Af66f3618c42(props: any) {
  const Link = AppStore.presets["Link"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} ShortHeader23d209925bf248b39101Af66f3618c42 site-header`}>
      <div className="background-image" />
      <div className="header-top">
        {props["linked-logo"] || <Link className="LinkedLogo5a315d7c2f4d4cd3923aE0bd231c8386" parentTag={buildClassName("LinkedLogo5a315d7c2f4d4cd3923aE0bd231c8386", parentTag)} label={<DefaultLogo61ee95b52f514b33A182C65924ce10ad parentTag="LabelFc90cbb74dd84165Acd26faa81729288" alt="logo" />} {...props} />}
        {props["navigation"] || <PrimaryNavigation className="NavigationB53e0845F2574f93A6fd08db6ab675ac" parentTag={buildClassName("NavigationB53e0845F2574f93A6fd08db6ab675ac", parentTag)} navMenuSlug="members-primary-nav" {...props} />}
      </div>
    </div>
  );
}

// id: "c7b3a7b5-b04f-4457-a2be-ca2f064fa800"
// title: "Public Events Page"
// type: :html
// key: "public-events-page"
// parent_id: nil
export function PublicEventsPageC7b3a7b5B04f4457A2beCa2f064fa800(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicEventsPageC7b3a7b5B04f4457A2beCa2f064fa800 gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeader46e8287a4bfb4421A3bdAdd5b7823e32 parentTag="Header8f4a57b77c80412091a121e9c1c38d7b" title="Public Events" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer2a2d3898C2ea4e5e9ad11536335d77f7" {...props} />}
    </div>
  );
}

// id: "994b4986-78ab-4035-b292-5bd122781f94"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "1018f660-f5d1-490e-a486-2d1112478006"
export function Sponsors994b498678ab4035B2925bd122781f94(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="Sponsors994b498678ab4035B2925bd122781f94" parentTag={buildClassName("Sponsors994b498678ab4035B2925bd122781f94", parentTag)} {...props} />
  );
}

// id: "66f1cd58-3f71-4f72-841d-1ab5d051be67"
// title: ""
// type: :gf_preset
// key: "main-content"
// parent_id: "bf094e87-9891-4718-9d43-654487499262"
export function MainContent66f1cd583f714f72841d1ab5d051be67(props: any) {
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageContentSimplified className="MainContent66f1cd583f714f72841d1ab5d051be67" parentTag={buildClassName("MainContent66f1cd583f714f72841d1ab5d051be67", parentTag)} contentSlug="polytopia-2026-schedule-main" {...props} />
  );
}

// id: "a75825ab-16ea-4b46-8759-44fd1e10c499"
// title: "Header"
// type: :reference
// key: "header"
// parent_id: "2c6604e0-3fd4-4a62-a699-10a54631f001"
export function HeaderA75825ab16ea4b46875944fd1e10c499(props: any) {
  return (
    <SecondaryMarketingHeader46e8287a4bfb4421A3bdAdd5b7823e32 parentTag="HeaderA75825ab16ea4b46875944fd1e10c499" title="Polytopia 2024" {...props} />
  );
}

// id: "501fc3bc-ca97-4cde-91f7-cbd4d7ba33e6"
// title: ""
// type: :reference
// key: "header"
// parent_id: "51196b24-76d2-4b11-bfe5-f3accc666a93"
export function Header501fc3bcCa974cde91f7Cbd4d7ba33e6(props: any) {
  return (
    <MembersAreaHeaderF9d2c204Ca514b8bA2a4A44a7305a5fd parentTag="Header501fc3bcCa974cde91f7Cbd4d7ba33e6" {...props} />
  );
}

// id: "791e01b1-0502-4345-9583-7d0461dc458a"
// title: ""
// type: :gf_preset
// key: "button"
// parent_id: "280ad86c-331c-4a3e-bf8d-ccfd86ecff1d"
export function Button791e01b10502434595837d0461dc458a(props: any) {
  const Button = AppStore.presets["Button"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Button className="Button791e01b10502434595837d0461dc458a" parentTag={buildClassName("Button791e01b10502434595837d0461dc458a", parentTag)} href="/join" label="Join Us" {...props} />
  );
}

// id: "f8e68387-62ac-497f-a441-5fa8504f3532"
// title: ""
// type: :text
// key: "buttonClass"
// parent_id: "b5bdf197-84c6-4598-ba9a-e3cca29275dd"
export const ButtonClassF8e6838762ac497fA4415fa8504f3532 = "inline-block px-12 py-3 hover:brightness-110 transition duration";

// id: "fda3b7f8-855e-43b0-a1bc-d8679efa709a"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "22c216b0-2145-4899-9f10-1a141bf14483"
export const PostSlugFda3b7f8855e43b0A1bcD8679efa709a = "polytopia-2025-sponsors";

// id: "c9f37237-4c44-484e-ad96-104e6bd05901"
// title: ""
// type: :text
// key: "className"
// parent_id: "9761af07-bc2d-4c8d-afc6-1172ab1207c8"
export const ClassNameC9f372374c44484eAd96104e6bd05901 = "public-header-with-hero secondary-page";

// id: "ed1183eb-11b5-4022-b5d4-5887af34d301"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "802d08a7-5821-4871-9f0b-a58951f4df72"
export const ContentSlugEd1183eb11b54022B5d45887af34d301 = "polytopia-2025-presenters-intro-text";

// id: "8d2be350-1f3a-4de4-ba4d-75148b50e524"
// title: ""
// type: :text
// key: "as"
// parent_id: "be9a936f-f4ef-404f-b5fe-da9b95a18828"
export const As8d2be3501f3a4de4Ba4d75148b50e524 = "header";

// id: "9c57a08b-f651-4b6a-a4f8-ca91f8dcc91e"
// title: ""
// type: :text
// key: "title"
// parent_id: "26984018-0df9-4a1f-b9e2-bb3426a5ee92"
export const Title9c57a08bF6514b6aA4f8Ca91f8dcc91e = "Secondary Page";

// id: "3538a127-aa33-4e05-90c1-d5d4f38c6467"
// title: "About Us"
// type: :html
// key: "about-us-page"
// parent_id: nil
export function AboutUsPage3538a127Aa334e0590c1D5d4f38c6467(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutUsPage3538a127Aa334e0590c1D5d4f38c6467 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeader46e8287a4bfb4421A3bdAdd5b7823e32 parentTag="HeaderB9b7eae57d3348a7B4edC1c529a55440" title="About Us" {...props} />}
      {props["body"] || <MarketingBody5e4b61e6136b4c329be890b33fbc406b parentTag="Body2a4842cfA3b14e419bc1Fd8dc26188f8" postSlug="about-us-posts" {...props} />}
      {props["footer"] || <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer5071c4adD91440a18a1f22f710551a4b" {...props} />}
    </div>
  );
}

// id: "9ec12065-efa7-4e60-bc84-6e6f1cd50f38"
// title: "HREF"
// type: :text
// key: "href"
// parent_id: nil
export const Href9ec12065Efa74e60Bc846e6f1cd50f38 = "/";

// id: "24e32cc4-3d54-4ba8-87ac-b80c8b270717"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "7d24c00a-3e51-45c3-8501-2d4fd3079d1f"
export function Sponsors24e32cc43d544ba887acB80c8b270717(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="Sponsors24e32cc43d544ba887acB80c8b270717" parentTag={buildClassName("Sponsors24e32cc43d544ba887acB80c8b270717", parentTag)} {...props} />
  );
}

// id: "5df4a4ad-93b2-4322-b06a-1e233b044515"
// title: "Footer"
// type: :reference
// key: "footer"
// parent_id: "2c6604e0-3fd4-4a62-a699-10a54631f001"
export function Footer5df4a4ad93b24322B06a1e233b044515(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer5df4a4ad93b24322B06a1e233b044515" {...props} />
  );
}

// id: "fa77a35f-a4d6-44a5-a406-5d41a36addf1"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "a205bb2d-69d3-4114-8f06-d8094dda6655"
export function FooterFa77a35fA4d644a5A4065d41a36addf1(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="FooterFa77a35fA4d644a5A4065d41a36addf1" {...props} />
  );
}

// id: "5377d850-007f-45aa-b5e1-5e86f61be8ab"
// title: ""
// type: :reference
// key: "header"
// parent_id: "0ca15a34-ab6e-4dc0-9e8d-8d582e9365e6"
export function Header5377d850007f45aaB5e15e86f61be8ab(props: any) {
  return (
    <SecondaryMarketingHeader46e8287a4bfb4421A3bdAdd5b7823e32 parentTag="Header5377d850007f45aaB5e15e86f61be8ab" title="Resources" {...props} />
  );
}

// id: "bf2025ba-94f0-4a34-8106-a31f1afff587"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone I9XQT7FHAZPJGAC15 Clone YBYEQWBTJ7M1RURES Clone 9QERD06Z1IRV6P2WO Clone FSRRZ624M1ZWVYIEM"
// type: :reference
// key: "footer"
// parent_id: "b93fa53c-0235-4c33-a2a7-4b3bfe6b8464"
export function FooterBf2025ba94f04a348106A31f1afff587(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="FooterBf2025ba94f04a348106A31f1afff587" {...props} />
  );
}

// id: "b1fba87d-f7ed-4567-aa6d-596b27ee9ac7"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "6d28a864-391b-46b0-8e2e-ce2784eb6f17"
export function CopyrightB1fba87dF7ed4567Aa6d596b27ee9ac7(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="CopyrightB1fba87dF7ed4567Aa6d596b27ee9ac7" parentTag={buildClassName("CopyrightB1fba87dF7ed4567Aa6d596b27ee9ac7", parentTag)} {...props} />
  );
}

// id: "189cd85c-f9dd-465d-b279-adf3a8049e0c"
// title: ""
// type: :text
// key: "className"
// parent_id: "ddb7077f-a765-4a1d-8bb0-da405d0a90a8"
export const ClassName189cd85cF9dd465dB279Adf3a8049e0c = "public-header-with-hero secondary-page";

// id: "a15a4a85-d2a2-4f79-aec8-959fd8fc9ccd"
// title: ""
// type: :text
// key: "subType"
// parent_id: "597719ea-4fc9-492c-bc03-95666caf81d8"
export const SubTypeA15a4a85D2a24f79Aec8959fd8fc9ccd = "header_with_hero";

// id: "3bf58868-ec1a-4da8-b8aa-e2c5dc2c907d"
// title: ""
// type: :text
// key: "as"
// parent_id: "ddb7077f-a765-4a1d-8bb0-da405d0a90a8"
export const As3bf58868Ec1a4da8B8aaE2c5dc2c907d = "header";

// id: "5fc0225d-b08b-440d-8ab5-33a459afb2d6"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "72421d8b-740d-40bb-97d2-a03507bc304d"
export const NavMenuSlug5fc0225dB08b440d8ab533a459afb2d6 = "members-primary-nav";

// id: "04defbde-fc93-4d5b-81d2-a1f4784e99e3"
// title: ""
// type: :text
// key: "className"
// parent_id: "597719ea-4fc9-492c-bc03-95666caf81d8"
export const ClassName04defbdeFc934d5b81d2A1f4784e99e3 = "public-header-with-hero secondary-page";

// id: "13343270-aaef-4ba9-a004-8f74b7d0702d"
// title: "Home Header"
// type: :html
// key: "home-header"
// parent_id: nil
export function HomeHeader13343270Aaef4ba9A0048f74b7d0702d(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomeHeader13343270Aaef4ba9A0048f74b7d0702d site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopB6c2307bD6814f14A258B20d9016e163 parentTag="HeaderTop1b708421937b491f995b83b9957943fd" {...props} />}
      </div>
      {props["hero"] || <Hero className="Hero539b6810145a4403Bb2a849d0a68fb45" parentTag={buildClassName("Hero539b6810145a4403Bb2a849d0a68fb45", parentTag)} postSlug="home-hero" {...props} />}
    </div>
  );
}

// id: "280ad86c-331c-4a3e-bf8d-ccfd86ecff1d"
// title: "Home Page Hero"
// type: :html
// key: "home-page-hero"
// parent_id: nil
export function HomePageHero280ad86c331c4a3eBf8dCcfd86ecff1d(props: any) {
  const Button = AppStore.presets["Button"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePageHero280ad86c331c4a3eBf8dCcfd86ecff1d hero`}>
      <div className="title">
        Our mission is to change the world by promoting healthy sexuality through community and education.
      </div>
      <div className="button">
        {props["button"] || <Button className="Button791e01b10502434595837d0461dc458a" parentTag={buildClassName("Button791e01b10502434595837d0461dc458a", parentTag)} href="/join" label="Join Us" {...props} />}
      </div>
    </div>
  );
}

// id: "1c69407b-3fdf-4b39-95e7-4c9e3b125231"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "6d28a864-391b-46b0-8e2e-ce2784eb6f17"
export function Groupflow1c69407b3fdf4b3995e74c9e3b125231(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow1c69407b3fdf4b3995e74c9e3b125231" parentTag={buildClassName("Groupflow1c69407b3fdf4b3995e74c9e3b125231", parentTag)} {...props} />
  );
}

// id: "96c94154-3a23-47ee-a633-3f74c461ed62"
// title: "Polytopia 2025 Schedule"
// type: :html
// key: "polytopia-2025-schedule"
// parent_id: nil
export function Polytopia2025Schedule96c941543a2347eeA6333f74c461ed62(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2025Schedule96c941543a2347eeA6333f74c461ed62 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="HeaderF64201039f714cc88193B7f48567090f" parentTag={buildClassName("HeaderF64201039f714cc88193B7f48567090f", parentTag)} contentSlug="polytopia-2025-schedule-header-with-hero" subType="header_with_hero" as="header" className="public-header-with-hero secondary-page" {...props} />}
      <main>
        {props["main-content"] || <PageContentSimplified className="MainContent5ec7c6f359ad44079daa22ac0d484146" parentTag={buildClassName("MainContent5ec7c6f359ad44079daa22ac0d484146", parentTag)} contentSlug="polytopia-2025-schedule-main" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer443833d8Fbb5467581f54266d91b7df0" {...props} />}
    </div>
  );
}

// id: "27ebb718-2df7-42ba-a258-1b7815e0e4ef"
// title: "Home Page"
// type: :html
// key: "home-page"
// parent_id: nil
export function HomePage27ebb7182df742baA2581b7815e0e4ef(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePage27ebb7182df742baA2581b7815e0e4ef page gf-page-layout page gf-page-layout`}>
      {props["header"] || <HomeHeader13343270Aaef4ba9A0048f74b7d0702d parentTag="Header1a2bd1dc6e5d4ed1Ae98A8e79f50c560" {...props} />}
      {props["welcome-back"] || <WelcomeBackPopUp className="WelcomeBack14a06d70B335433c87868ff6c23dbb99" parentTag={buildClassName("WelcomeBack14a06d70B335433c87868ff6c23dbb99", parentTag)} {...props} />}
      {props["body"] || <MarketingBody5e4b61e6136b4c329be890b33fbc406b parentTag="BodyCa7acaeb54014709Bc40E751735ca206" {...props} />}
      {props["quote"] || <PageQuote className="QuoteF1ead8388e7d4d56995787255a036308" parentTag={buildClassName("QuoteF1ead8388e7d4d56995787255a036308", parentTag)} contentSlug="home-page-quote" {...props} />}
      {props["footer"] || <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="FooterB2e1337dA9e843cc99b91aaab7960131" {...props} />}
    </div>
  );
}

// id: "b627bba7-d381-49a0-a1a7-c1152e4938f6"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone I9XQT7FHAZPJGAC15 Clone NE93G482WP5J87HE7"
// type: :reference
// key: "footer"
// parent_id: "64a547e5-2697-4305-89f9-d0aef2a273c7"
export function FooterB627bba7D38149a0A1a7C1152e4938f6(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="FooterB627bba7D38149a0A1a7C1152e4938f6" {...props} />
  );
}

// id: "ddb7077f-a765-4a1d-8bb0-da405d0a90a8"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "1018f660-f5d1-490e-a486-2d1112478006"
export function HeaderDdb7077fA7654a1d8bb0Da405d0a90a8(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderDdb7077fA7654a1d8bb0Da405d0a90a8" parentTag={buildClassName("HeaderDdb7077fA7654a1d8bb0Da405d0a90a8", parentTag)} subType="header_with_hero" className="public-header-with-hero secondary-page" as="header" contentSlug="polytopia-2025-handouts-header-with-hero" {...props} />
  );
}

// id: "902d49a9-867d-4691-97a3-6c227cb214db"
// title: ""
// type: :gf_preset
// key: "main-content"
// parent_id: "67f6f45b-0883-4561-b89e-9c3cc608e0df"
export function MainContent902d49a9867d469197a36c227cb214db(props: any) {
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageContentSimplified className="MainContent902d49a9867d469197a36c227cb214db" parentTag={buildClassName("MainContent902d49a9867d469197a36c227cb214db", parentTag)} contentSlug="polytopia-2025-workshops-content" {...props} />
  );
}

// id: "443833d8-fbb5-4675-81f5-4266d91b7df0"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone I9XQT7FHAZPJGAC15 Clone YBYEQWBTJ7M1RURES Clone 9QERD06Z1IRV6P2WO Clone RA2IOSI5WU9MZT94L"
// type: :reference
// key: "footer"
// parent_id: "96c94154-3a23-47ee-a633-3f74c461ed62"
export function Footer443833d8Fbb5467581f54266d91b7df0(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer443833d8Fbb5467581f54266d91b7df0" {...props} />
  );
}

// id: "03159174-a34f-4b94-a8dc-70fec2708368"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "7d24c00a-3e51-45c3-8501-2d4fd3079d1f"
export function Header03159174A34f4b94A8dc70fec2708368(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header03159174A34f4b94A8dc70fec2708368" parentTag={buildClassName("Header03159174A34f4b94A8dc70fec2708368", parentTag)} subType="header_with_hero" contentSlug="polytopia-2026-handouts-header-with-hero" className="public-header-with-hero secondary-page" as="header" {...props} />
  );
}

// id: "4cd242ea-76ab-497c-a844-5b45e1efef2b"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "1cd15230-2613-4410-a64d-86765a0fc3e9"
export const ContentSlug4cd242ea76ab497cA8445b45e1efef2b = "polytopia-2026-presenters-header-with-hero";

// id: "ecc8abf3-dd0f-4ecc-83e6-52c5313d8445"
// title: ""
// type: :text
// key: "class"
// parent_id: "163ca03a-ae8e-434b-9112-3c65cee9700d"
export const ClassEcc8abf3Dd0f4ecc83e652c5313d8445 = "linked-logo";

// id: "c5b279f4-f192-49a4-903c-456ee01b5a02"
// title: ""
// type: :text
// key: "title"
// parent_id: "cce9cc59-87a6-4a32-8339-3b93d7e0c2f5"
export const TitleC5b279f4F19249a4903c456ee01b5a02 = "Join Us";

// id: "797439c3-fc5f-4ca7-87c6-ccc0c0ec1431"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "ec095376-b5e7-4bd6-a44f-84e988e3c4a2"
export const ContentSlug797439c3Fc5f4ca787c6Ccc0c0ec1431 = "polytopia-page-sponsors";

// id: "50867fc8-0d39-4caa-9d07-aabad31b5306"
// title: ""
// type: :text
// key: "url"
// parent_id: "163ca03a-ae8e-434b-9112-3c65cee9700d"
export const Url50867fc80d394caa9d07Aabad31b5306 = "/";

// id: "bd07d0e7-d7b6-404e-8f58-5e536f2480ed"
// title: "Page Quote"
// type: :html
// key: "page-quote"
// parent_id: nil
export function PageQuoteBd07d0e7D7b6404e8f585e536f2480ed(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PageQuoteBd07d0e7D7b6404e8f585e536f2480ed`}>
      <div>
      </div>
      <div>
      </div>
    </div>
  );
}

// id: "b93fa53c-0235-4c33-a2a7-4b3bfe6b8464"
// title: "Polytopia 2026 Workshops"
// type: :html
// key: "polytopia-2026-workshops"
// parent_id: nil
export function Polytopia2026WorkshopsB93fa53c02354c33A2a74b3bfe6b8464(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2026WorkshopsB93fa53c02354c33A2a74b3bfe6b8464 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="HeaderA08faa137d9c4bbf9352Ff58a8439fc3" parentTag={buildClassName("HeaderA08faa137d9c4bbf9352Ff58a8439fc3", parentTag)} className="public-header-with-hero secondary-page" contentSlug="polytopia-2026-workshops-header-with-hero" subType="header_with_hero" as="header" {...props} />}
      <main>
        {props["main-content"] || <PageContentSimplified className="MainContent524ed79602b9458fBb09Ee30af38e811" parentTag={buildClassName("MainContent524ed79602b9458fBb09Ee30af38e811", parentTag)} contentSlug="polytopia-2026-workshops-content" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="FooterBf2025ba94f04a348106A31f1afff587" {...props} />}
    </div>
  );
}

// id: "0ef54779-cb76-49cc-bf06-6b9d2d9af470"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone I9XQT7FHAZPJGAC15"
// type: :reference
// key: "footer"
// parent_id: "77f22cd6-ae63-49b9-ae76-f1f1c696d4b5"
export function Footer0ef54779Cb7649ccBf066b9d2d9af470(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer0ef54779Cb7649ccBf066b9d2d9af470" {...props} />
  );
}

// id: "487b8ff0-6565-4888-82df-11125c29fce5"
// title: ""
// type: :reference
// key: "header"
// parent_id: "31431831-0fb1-4e5f-880b-b30691a5f62e"
export function Header487b8ff06565488882df11125c29fce5(props: any) {
  return (
    <SecondaryMarketingHeader46e8287a4bfb4421A3bdAdd5b7823e32 parentTag="Header487b8ff06565488882df11125c29fce5" title="Join Us" {...props} />
  );
}

// id: "8f4a57b7-7c80-4120-91a1-21e9c1c38d7b"
// title: ""
// type: :reference
// key: "header"
// parent_id: "c7b3a7b5-b04f-4457-a2be-ca2f064fa800"
export function Header8f4a57b77c80412091a121e9c1c38d7b(props: any) {
  return (
    <SecondaryMarketingHeader46e8287a4bfb4421A3bdAdd5b7823e32 parentTag="Header8f4a57b77c80412091a121e9c1c38d7b" title="Public Events" {...props} />
  );
}

// id: "6fb449f3-46a3-4f67-a737-c659e158928a"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "df06157b-080e-4a94-9534-d6fd5e4e141c"
export function Cards6fb449f346a34f67A737C659e158928a(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards6fb449f346a34f67A737C659e158928a" parentTag={buildClassName("Cards6fb449f346a34f67A737C659e158928a", parentTag)} postSlug="polytopia-2026-cards" {...props} />
  );
}

// id: "cc2ee07d-925e-48fa-a344-d1b4d8325012"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "95e743a8-acec-4d29-881a-8e5ae3f0995e"
export const ContentSlugCc2ee07d925e48faA344D1b4d8325012 = "polytopia-2026-presenters-intro-text";

// id: "011666d4-4c5d-49fb-900b-a737bd4a706d"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "be9a936f-f4ef-404f-b5fe-da9b95a18828"
export const ContentSlug011666d44c5d49fb900bA737bd4a706d = "polytopia-2025-presenters-header-with-hero";

// id: "ef45f796-5a62-43b4-bb4d-bfd24de6486b"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "49c5dba9-edc5-491d-b9cf-622db50f5735"
export const PostSlugEf45f7965a6243b4Bb4dBfd24de6486b = "polytopia-2025-presenters-cards";

// id: "3be555e2-c82b-47de-b2e1-8e8174be14f8"
// title: ""
// type: :text
// key: "subType"
// parent_id: "f87a6608-a300-475c-8ae7-df08bbbc1158"
export const SubType3be555e2C82b47deB2e18e8174be14f8 = "header_with_hero";

// id: "5960a13a-bea8-4838-af13-ca4ddfbdaeb6"
// title: "Levels 1-4 Explained"
// type: :html
// key: "about-leveling-page"
// parent_id: nil
export function AboutLevelingPage5960a13aBea84838Af13Ca4ddfbdaeb6(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutLevelingPage5960a13aBea84838Af13Ca4ddfbdaeb6 gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeader46e8287a4bfb4421A3bdAdd5b7823e32 parentTag="Header57268d692a464de9Abaf033dab4ad77b" title="Leveling" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="FooterEd22b18668644af0Ba43A5f4515ace0f" {...props} />}
    </div>
  );
}

// id: "f6420103-9f71-4cc8-8193-b7f48567090f"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "96c94154-3a23-47ee-a633-3f74c461ed62"
export function HeaderF64201039f714cc88193B7f48567090f(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderF64201039f714cc88193B7f48567090f" parentTag={buildClassName("HeaderF64201039f714cc88193B7f48567090f", parentTag)} contentSlug="polytopia-2025-schedule-header-with-hero" subType="header_with_hero" as="header" className="public-header-with-hero secondary-page" {...props} />
  );
}

// id: "9761af07-bc2d-4c8d-afc6-1172ab1207c8"
// title: "Header Clone SiJc8owDIOQgqYh Clone F82SSDIS4SM8PPXZH"
// type: :gf_preset
// key: "header"
// parent_id: "77f22cd6-ae63-49b9-ae76-f1f1c696d4b5"
export function Header9761af07Bc2d4c8dAfc61172ab1207c8(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header9761af07Bc2d4c8dAfc61172ab1207c8" parentTag={buildClassName("Header9761af07Bc2d4c8dAfc61172ab1207c8", parentTag)} subType="header_with_hero" className="public-header-with-hero secondary-page" contentSlug="polytopia-2025-sponsors-header-with-hero" as="header" {...props} />
  );
}

// id: "be9a936f-f4ef-404f-b5fe-da9b95a18828"
// title: "Header Clone SiJc8owDIOQgqYh Clone F82SSDIS4SM8PPXZH Clone FAQQBXNH68T50FSXS"
// type: :gf_preset
// key: "header"
// parent_id: "161ec63b-1b36-486e-b50e-3fce09959017"
export function HeaderBe9a936fF4ef404fB5feDa9b95a18828(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderBe9a936fF4ef404fB5feDa9b95a18828" parentTag={buildClassName("HeaderBe9a936fF4ef404fB5feDa9b95a18828", parentTag)} className="public-header-with-hero secondary-page" as="header" contentSlug="polytopia-2025-presenters-header-with-hero" subType="header_with_hero" {...props} />
  );
}

// id: "a08faa13-7d9c-4bbf-9352-ff58a8439fc3"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "b93fa53c-0235-4c33-a2a7-4b3bfe6b8464"
export function HeaderA08faa137d9c4bbf9352Ff58a8439fc3(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderA08faa137d9c4bbf9352Ff58a8439fc3" parentTag={buildClassName("HeaderA08faa137d9c4bbf9352Ff58a8439fc3", parentTag)} className="public-header-with-hero secondary-page" contentSlug="polytopia-2026-workshops-header-with-hero" subType="header_with_hero" as="header" {...props} />
  );
}

// id: "2a4842cf-a3b1-4e41-9bc1-fd8dc26188f8"
// title: ""
// type: :reference
// key: "body"
// parent_id: "3538a127-aa33-4e05-90c1-d5d4f38c6467"
export function Body2a4842cfA3b14e419bc1Fd8dc26188f8(props: any) {
  return (
    <MarketingBody5e4b61e6136b4c329be890b33fbc406b parentTag="Body2a4842cfA3b14e419bc1Fd8dc26188f8" postSlug="about-us-posts" {...props} />
  );
}

// id: "516d7bfb-b25b-4173-a1a6-6fdeb815cdb4"
// title: ""
// type: :reference
// key: "body"
// parent_id: "2c6604e0-3fd4-4a62-a699-10a54631f001"
export function Body516d7bfbB25b4173A1a66fdeb815cdb4(props: any) {
  return (
    <MarketingCardsB5bdf19784c64598Ba9aE3cca29275dd parentTag="Body516d7bfbB25b4173A1a66fdeb815cdb4" postSlug="polytopia-2024" {...props} />
  );
}

// id: "d166df3f-e30c-4c21-abd2-6b92930810cd"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "597719ea-4fc9-492c-bc03-95666caf81d8"
export const ContentSlugD166df3fE30c4c21Abd26b92930810cd = "polytopia-2026-sponsors-header-with-hero";

// id: "796fe704-e2fc-44b6-ac1f-9da1ff3579db"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "501ee711-ff3f-45a5-a7a1-08d57a08acd4"
export const ContentSlug796fe704E2fc44b6Ac1f9da1ff3579db = "polytopia-2025-handouts-main";

// id: "99b6f8ae-e293-461e-8318-3b170d6f8095"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "af40ecc3-6856-46f7-b38e-dfee76dd4b1c"
export const NavMenuSlug99b6f8aeE293461e83183b170d6f8095 = "marketing-primary-nav";

// id: "fc90cbb7-4dd8-4165-acd2-6faa81729288"
// title: ""
// type: :reference
// key: "label"
// parent_id: "5a315d7c-2f4d-4cd3-923a-e0bd231c8386"
export function LabelFc90cbb74dd84165Acd26faa81729288(props: any) {
  return (
    <DefaultLogo61ee95b52f514b33A182C65924ce10ad parentTag="LabelFc90cbb74dd84165Acd26faa81729288" {...props} />
  );
}

// id: "d5e2dcb1-da46-4d2b-af06-be8d96db12ef"
// title: ""
// type: :text
// key: "subType"
// parent_id: "a08faa13-7d9c-4bbf-9352-ff58a8439fc3"
export const SubTypeD5e2dcb1Da464d2bAf06Be8d96db12ef = "header_with_hero";

// id: "67429ef0-5c42-457a-a9ae-d89ea03fd5ea"
// title: "Polytopia 2024 Workshops"
// type: :html
// key: "polytopia-2024-workshops"
// parent_id: nil
export function Polytopia2024Workshops67429ef05c42457aA9aeD89ea03fd5ea(props: any) {
  const PageContent = AppStore.presets["PageContent"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2024Workshops67429ef05c42457aA9aeD89ea03fd5ea page gf-page-layout page gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeader46e8287a4bfb4421A3bdAdd5b7823e32 parentTag="Header64031602878b4189B772475df5163551" title="Polytopia 2024 Workshops" {...props} />}
      <main>
        {props["body"] || <PageContent className="Body6809bc81F7004207A1e7328015756367" parentTag={buildClassName("Body6809bc81F7004207A1e7328015756367", parentTag)} {...props} />}
      </main>
      {props["footer"] || <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer9610b3127ecb47acA5a2Cc3017b7974b" {...props} />}
    </div>
  );
}

// id: "cae48e4a-d8ab-4484-afe9-7c2058b2e7e3"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "106561f4-6b13-4d2e-93b8-980dbecda65c"
export function CardsCae48e4aD8ab4484Afe97c2058b2e7e3(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="CardsCae48e4aD8ab4484Afe97c2058b2e7e3" parentTag={buildClassName("CardsCae48e4aD8ab4484Afe97c2058b2e7e3", parentTag)} postSlug="polytopia-2025" {...props} />
  );
}

// id: "f10eadf8-147f-4cff-9240-85839b329cd8"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "6d28a864-391b-46b0-8e2e-ce2784eb6f17"
export function LinksF10eadf8147f4cff924085839b329cd8(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="LinksF10eadf8147f4cff924085839b329cd8" parentTag={buildClassName("LinksF10eadf8147f4cff924085839b329cd8", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "a18ad67e-2793-4c63-9a5b-e5fc84c36d63"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone PDYMUIYORNVKPIXNX"
// type: :reference
// key: "footer"
// parent_id: "df06157b-080e-4a94-9534-d6fd5e4e141c"
export function FooterA18ad67e27934c639a5bE5fc84c36d63(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="FooterA18ad67e27934c639a5bE5fc84c36d63" {...props} />
  );
}

// id: "2735cda8-a2a3-475e-8198-4baf37ebb4bd"
// title: "Footer Clone xRXtkVcbB7vf9dR"
// type: :reference
// key: "footer"
// parent_id: "106561f4-6b13-4d2e-93b8-980dbecda65c"
export function Footer2735cda8A2a3475e81984baf37ebb4bd(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer2735cda8A2a3475e81984baf37ebb4bd" {...props} />
  );
}

// id: "9610b312-7ecb-47ac-a5a2-cc3017b7974b"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "67429ef0-5c42-457a-a9ae-d89ea03fd5ea"
export function Footer9610b3127ecb47acA5a2Cc3017b7974b(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer9610b3127ecb47acA5a2Cc3017b7974b" {...props} />
  );
}

// id: "2a2d3898-c2ea-4e5e-9ad1-1536335d77f7"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "c7b3a7b5-b04f-4457-a2be-ca2f064fa800"
export function Footer2a2d3898C2ea4e5e9ad11536335d77f7(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer2a2d3898C2ea4e5e9ad11536335d77f7" {...props} />
  );
}

// id: "bbe38b65-9566-458b-8c6b-aab3653cc136"
// title: ""
// type: :text
// key: "className"
// parent_id: "802d08a7-5821-4871-9f0b-a58951f4df72"
export const ClassNameBbe38b659566458b8c6bAab3653cc136 = "intro-text";

// id: "78fa82d6-49aa-447f-95ca-161528c087be"
// title: ""
// type: :text
// key: "subType"
// parent_id: "1cd15230-2613-4410-a64d-86765a0fc3e9"
export const SubType78fa82d649aa447f95ca161528c087be = "header_with_hero";

// id: "00404a42-5300-44b1-8697-f32ff92e3205"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "539b6810-145a-4403-bb2a-849d0a68fb45"
export const PostSlug00404a42530044b18697F32ff92e3205 = "home-hero";

// id: "3691ebba-2c55-4760-b3fb-797f7119c6a1"
// title: ""
// type: :text
// key: "title"
// parent_id: "551e0397-50c7-49c2-b65b-01c58185db98"
export const Title3691ebba2c554760B3fb797f7119c6a1 = "Secondary Marketing Title 2";

// id: "bdada434-0000-45fb-a227-255ae16de7d2"
// title: ""
// type: :text
// key: "label"
// parent_id: "791e01b1-0502-4345-9583-7d0461dc458a"
export const LabelBdada434000045fbA227255ae16de7d2 = "Join Us";

// id: "106561f4-6b13-4d2e-93b8-980dbecda65c"
// title: "Polytopia 2025"
// type: :html
// key: "polytopia-2025"
// parent_id: nil
export function Polytopia2025106561f46b134d2e93b8980dbecda65c(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Polytopia2025106561f46b134d2e93b8980dbecda65c page gf-page-layout page gf-page-layout`}>
      {props["header"] || <ContentItem className="HeaderBaef190d6110483bA2048916d38c11d3" parentTag={buildClassName("HeaderBaef190d6110483bA2048916d38c11d3", parentTag)} title="Polytopia 2025" subType="header_with_hero" contentSlug="polytopia-2025-header-with-hero" className="public-header-with-hero secondary-page" as="header" {...props} />}
      <main>
        {props["cards"] || <MarketingCards className="CardsCae48e4aD8ab4484Afe97c2058b2e7e3" parentTag={buildClassName("CardsCae48e4aD8ab4484Afe97c2058b2e7e3", parentTag)} postSlug="polytopia-2025" {...props} />}
        {props["sponsors"] || <ContentSnippet className="SponsorsEc095376B5e74bd6A44f84e988e3c4a2" parentTag={buildClassName("SponsorsEc095376B5e74bd6A44f84e988e3c4a2", parentTag)} contentSlug="polytopia-page-sponsors" {...props} />}
      </main>
      {props["footer"] || <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer2735cda8A2a3475e81984baf37ebb4bd" {...props} />}
    </div>
  );
}

// id: "22c216b0-2145-4899-9f10-1a141bf14483"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "77f22cd6-ae63-49b9-ae76-f1f1c696d4b5"
export function Cards22c216b0214548999f101a141bf14483(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards22c216b0214548999f101a141bf14483" parentTag={buildClassName("Cards22c216b0214548999f101a141bf14483", parentTag)} postSlug="polytopia-2025-sponsors" {...props} />
  );
}

// id: "d2d37f8a-8ab0-4b1b-ad12-4dc21d463dd4"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "a37c2102-173c-4d49-a14a-f3f10597a1f5"
export function FooterD2d37f8a8ab04b1bAd124dc21d463dd4(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="FooterD2d37f8a8ab04b1bAd124dc21d463dd4" {...props} />
  );
}

// id: "597719ea-4fc9-492c-bc03-95666caf81d8"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "bf094e87-9891-4718-9d43-654487499262"
export function Header597719ea4fc9492cBc0395666caf81d8(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header597719ea4fc9492cBc0395666caf81d8" parentTag={buildClassName("Header597719ea4fc9492cBc0395666caf81d8", parentTag)} subType="header_with_hero" className="public-header-with-hero secondary-page" contentSlug="polytopia-2026-sponsors-header-with-hero" as="header" {...props} />
  );
}

// id: "f85d344c-fc5a-4722-b1b1-cfec30d7810e"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone I9XQT7FHAZPJGAC15 Clone YBYEQWBTJ7M1RURES Clone IP70JVLKGR2BY5BJB"
// type: :reference
// key: "footer"
// parent_id: "a4867a33-b561-450d-85a9-36f67e3845ab"
export function FooterF85d344cFc5a4722B1b1Cfec30d7810e(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="FooterF85d344cFc5a4722B1b1Cfec30d7810e" {...props} />
  );
}

// id: "1e33bc02-924b-454e-9974-eb8dbe154fa6"
// title: ""
// type: :text
// key: "title"
// parent_id: "d85a5202-4c28-4d7f-8df2-671b4d39473a"
export const Title1e33bc02924b454e9974Eb8dbe154fa6 = "Default Title";

// id: "5a315d7c-2f4d-4cd3-923a-e0bd231c8386"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "23d20992-5bf2-48b3-9101-af66f3618c42"
export function LinkedLogo5a315d7c2f4d4cd3923aE0bd231c8386(props: any) {
  const Link = AppStore.presets["Link"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo5a315d7c2f4d4cd3923aE0bd231c8386" parentTag={buildClassName("LinkedLogo5a315d7c2f4d4cd3923aE0bd231c8386", parentTag)} label={<DefaultLogo61ee95b52f514b33A182C65924ce10ad parentTag="LabelFc90cbb74dd84165Acd26faa81729288" alt="logo" />} {...props} />
  );
}

// id: "bb9fe71d-fe5b-4031-9f4c-0e6a8421dc06"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "a3c1651d-f463-4b35-9ce1-c094693dba72"
export const NavMenuSlugBb9fe71dFe5b40319f4c0e6a8421dc06 = "members-primary-nav";

// id: "b759dff1-674c-4e97-903b-07575f07e6a6"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "b40f2d0a-99d0-4cd2-a255-8f76555a3c20"
export const PostSlugB759dff1674c4e97903b07575f07e6a6 = "polytopia-2026-sponsors-cards";

// id: "a0e4a7c1-73f3-49f9-a063-c3f696fb39fe"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "2a4842cf-a3b1-4e41-9bc1-fd8dc26188f8"
export const PostSlugA0e4a7c173f349f9A063C3f696fb39fe = "about-us-posts";

// id: "b41acd26-79e9-48de-90fb-8523c1c93428"
// title: ""
// type: :text
// key: "subType"
// parent_id: "baef190d-6110-483b-a204-8916d38c11d3"
export const SubTypeB41acd2679e948de90fb8523c1c93428 = "header_with_hero";

// id: "1cdfc5b3-0906-437e-993e-f87d9b418138"
// title: "Label"
// type: :reference
// key: "label"
// parent_id: nil
export function Label1cdfc5b30906437e993eF87d9b418138(props: any) {
  return (
    <DefaultLogo61ee95b52f514b33A182C65924ce10ad parentTag="Label1cdfc5b30906437e993eF87d9b418138" {...props} />
  );
}

// id: "7acf5ec7-41ce-4350-8e6b-fefa72e3f7c3"
// title: "Header"
// type: :gf_preset
// key: "header"
// parent_id: "64a547e5-2697-4305-89f9-d0aef2a273c7"
export function Header7acf5ec741ce43508e6bFefa72e3f7c3(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header7acf5ec741ce43508e6bFefa72e3f7c3" parentTag={buildClassName("Header7acf5ec741ce43508e6bFefa72e3f7c3", parentTag)} className="public-header-with-hero secondary-page" contentSlug="polytopia-2025-sponsors-header-with-hero" subType="header_with_hero" as="header" {...props} />
  );
}

// id: "57ac424f-10d4-4853-ad47-c3ae22149f16"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone I9XQT7FHAZPJGAC15 Clone YBYEQWBTJ7M1RURES Clone 9QERD06Z1IRV6P2WO Clone RA2IOSI5WU9MZT94L Clone X60TRD0XRW2DZ77ZB Clone 0XGEAUIWHNJ3APNRS"
// type: :reference
// key: "footer"
// parent_id: "7d24c00a-3e51-45c3-8501-2d4fd3079d1f"
export function Footer57ac424f10d44853Ad47C3ae22149f16(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer57ac424f10d44853Ad47C3ae22149f16" {...props} />
  );
}

// id: "1b708421-937b-491f-995b-83b9957943fd"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "13343270-aaef-4ba9-a004-8f74b7d0702d"
export function HeaderTop1b708421937b491f995b83b9957943fd(props: any) {
  return (
    <DefaultHeaderTopB6c2307bD6814f14A258B20d9016e163 parentTag="HeaderTop1b708421937b491f995b83b9957943fd" {...props} />
  );
}

// id: "9683a88f-e786-44bd-b33c-efaa37c55090"
// title: "Footer Clone xRXtkVcbB7vf9dR Clone I9XQT7FHAZPJGAC15 Clone YBYEQWBTJ7M1RURES"
// type: :reference
// key: "footer"
// parent_id: "161ec63b-1b36-486e-b50e-3fce09959017"
export function Footer9683a88fE78644bdB33cEfaa37c55090(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer9683a88fE78644bdB33cEfaa37c55090" {...props} />
  );
}

// id: "ed22b186-6864-4af0-ba43-a5f4515ace0f"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "5960a13a-bea8-4838-af13-ca4ddfbdaeb6"
export function FooterEd22b18668644af0Ba43A5f4515ace0f(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="FooterEd22b18668644af0Ba43A5f4515ace0f" {...props} />
  );
}

// id: "9a64e7ce-3f08-44fc-9241-4d591d8eca13"
// title: ""
// type: :text
// key: "className"
// parent_id: "2892b866-ab8c-47d8-9674-7dd8ad0c3d36"
export const ClassName9a64e7ce3f0844fc92414d591d8eca13 = "public-header-with-hero secondary-page";

// id: "695781b2-cc40-40e3-bcea-7c61c121a83a"
// title: ""
// type: :text
// key: "as"
// parent_id: "a08faa13-7d9c-4bbf-9352-ff58a8439fc3"
export const As695781b2Cc4040e3Bcea7c61c121a83a = "header";

// id: "7964f765-4b3d-4327-a835-81b488e5e5c4"
// title: ""
// type: :text
// key: "subType"
// parent_id: "be9a936f-f4ef-404f-b5fe-da9b95a18828"
export const SubType7964f7654b3d4327A83581b488e5e5c4 = "header_with_hero";

// id: "0cb6889a-c95b-4acf-9f77-dc4e6578a87b"
// title: ""
// type: :text
// key: "as"
// parent_id: "597719ea-4fc9-492c-bc03-95666caf81d8"
export const As0cb6889aC95b4acf9f77Dc4e6578a87b = "header";

// id: "d69fb03d-7dae-438d-aedc-7d23e118c7c0"
// title: ""
// type: :text
// key: "subType"
// parent_id: "7acf5ec7-41ce-4350-8e6b-fefa72e3f7c3"
export const SubTypeD69fb03d7dae438dAedc7d23e118c7c0 = "header_with_hero";

// id: "95e743a8-acec-4d29-881a-8e5ae3f0995e"
// title: ""
// type: :gf_preset
// key: "intro"
// parent_id: "a4867a33-b561-450d-85a9-36f67e3845ab"
export function Intro95e743a8Acec4d29881a8e5ae3f0995e(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="Intro95e743a8Acec4d29881a8e5ae3f0995e" parentTag={buildClassName("Intro95e743a8Acec4d29881a8e5ae3f0995e", parentTag)} contentSlug="polytopia-2026-presenters-intro-text" className="intro-text" {...props} />
  );
}

// id: "eb50e0a2-b061-4f97-850a-f6b9008b129c"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "96c94154-3a23-47ee-a633-3f74c461ed62"
export function SponsorsEb50e0a2B0614f97850aF6b9008b129c(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="SponsorsEb50e0a2B0614f97850aF6b9008b129c" parentTag={buildClassName("SponsorsEb50e0a2B0614f97850aF6b9008b129c", parentTag)} {...props} />
  );
}

// id: "802d08a7-5821-4871-9f0b-a58951f4df72"
// title: ""
// type: :gf_preset
// key: "intro"
// parent_id: "161ec63b-1b36-486e-b50e-3fce09959017"
export function Intro802d08a7582148719f0bA58951f4df72(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="Intro802d08a7582148719f0bA58951f4df72" parentTag={buildClassName("Intro802d08a7582148719f0bA58951f4df72", parentTag)} contentSlug="polytopia-2025-presenters-intro-text" className="intro-text" {...props} />
  );
}

// id: "d73cf288-d983-4557-96c2-88167aaf88ac"
// title: ""
// type: :text
// key: "alt"
// parent_id: "61ee95b5-2f51-4b33-a182-c65924ce10ad"
export const AltD73cf288D983455796c288167aaf88ac = "logo";

// id: "a1b4a8cd-b617-4450-a3a5-2fb4e8795a41"
// title: ""
// type: :gf_preset
// key: "intro"
// parent_id: "64a547e5-2697-4305-89f9-d0aef2a273c7"
export function IntroA1b4a8cdB6174450A3a52fb4e8795a41(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="IntroA1b4a8cdB6174450A3a52fb4e8795a41" parentTag={buildClassName("IntroA1b4a8cdB6174450A3a52fb4e8795a41", parentTag)} contentSlug="polytopia-2026-sponsors-intro" {...props} />
  );
}

// id: "0ff005b2-34e1-4cfc-8ccc-13bd7dd26d97"
// title: ""
// type: :text
// key: "class"
// parent_id: "af40ecc3-6856-46f7-b38e-dfee76dd4b1c"
export const Class0ff005b234e14cfc8ccc13bd7dd26d97 = "navigation";

// id: "9a2881ab-2c9e-4945-825f-e6bcff4241c4"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "ddb7077f-a765-4a1d-8bb0-da405d0a90a8"
export const ContentSlug9a2881ab2c9e4945825fE6bcff4241c4 = "polytopia-2025-handouts-header-with-hero";

// id: "4c186061-c0aa-4826-9b32-bce6a5d19349"
// title: ""
// type: :text
// key: "title"
// parent_id: "5377d850-007f-45aa-b5e1-5e86f61be8ab"
export const Title4c186061C0aa48269b32Bce6a5d19349 = "Resources";

// id: "6bf192b4-2f86-4aae-b1c7-34806b92e8c3"
// title: ""
// type: :text
// key: "title"
// parent_id: "487b8ff0-6565-4888-82df-11125c29fce5"
export const Title6bf192b42f864aaeB1c734806b92e8c3 = "Join Us";

// id: "634bce00-3606-4c73-8b57-09f85463ff92"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "9761af07-bc2d-4c8d-afc6-1172ab1207c8"
export const ContentSlug634bce0036064c738b5709f85463ff92 = "polytopia-2025-sponsors-header-with-hero";

// id: "6809bc81-f700-4207-a1e7-328015756367"
// title: ""
// type: :gf_preset
// key: "body"
// parent_id: "67429ef0-5c42-457a-a9ae-d89ea03fd5ea"
export function Body6809bc81F7004207A1e7328015756367(props: any) {
  const PageContent = AppStore.presets["PageContent"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageContent className="Body6809bc81F7004207A1e7328015756367" parentTag={buildClassName("Body6809bc81F7004207A1e7328015756367", parentTag)} {...props} />
  );
}

// id: "49c5dba9-edc5-491d-b9cf-622db50f5735"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "161ec63b-1b36-486e-b50e-3fce09959017"
export function Cards49c5dba9Edc5491dB9cf622db50f5735(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards49c5dba9Edc5491dB9cf622db50f5735" parentTag={buildClassName("Cards49c5dba9Edc5491dB9cf622db50f5735", parentTag)} postSlug="polytopia-2025-presenters-cards" {...props} />
  );
}

// id: "ec095376-b5e7-4bd6-a44f-84e988e3c4a2"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "106561f4-6b13-4d2e-93b8-980dbecda65c"
export function SponsorsEc095376B5e74bd6A44f84e988e3c4a2(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="SponsorsEc095376B5e74bd6A44f84e988e3c4a2" parentTag={buildClassName("SponsorsEc095376B5e74bd6A44f84e988e3c4a2", parentTag)} contentSlug="polytopia-page-sponsors" {...props} />
  );
}

// id: "623956c8-733d-4814-9568-c62575c38f65"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "4cefad8c-dd5f-4905-8492-9ab0bffa628b"
export function Footer623956c8733d48149568C62575c38f65(props: any) {
  return (
    <DefaultFooter6d28a864391b46b08e2eCe2784eb6f17 parentTag="Footer623956c8733d48149568C62575c38f65" {...props} />
  );
}

// id: "2892b866-ab8c-47d8-9674-7dd8ad0c3d36"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "67f6f45b-0883-4561-b89e-9c3cc608e0df"
export function Header2892b866Ab8c47d896747dd8ad0c3d36(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header2892b866Ab8c47d896747dd8ad0c3d36" parentTag={buildClassName("Header2892b866Ab8c47d896747dd8ad0c3d36", parentTag)} subType="header_with_hero" className="public-header-with-hero secondary-page" as="header" contentSlug="polytopia-2025-workshops-header-with-hero" {...props} />
  );
}

// id: "bad9107a-c30a-4212-9ea0-6a656d4cfe2c"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "ac89e108-885e-4434-b264-29668083e15a"
export const ContentSlugBad9107aC30a42129ea06a656d4cfe2c = "polytopia-2026-sponsors";

// id: "a1de058b-987f-4ecf-aa54-f146746c9dbb"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "baef190d-6110-483b-a204-8916d38c11d3"
export const ContentSlugA1de058b987f4ecfAa54F146746c9dbb = "polytopia-2025-header-with-hero";

// id: "f56f3184-3793-41fa-bf26-59bd1b6c9aa9"
// title: ""
// type: :text
// key: "className"
// parent_id: "baef190d-6110-483b-a204-8916d38c11d3"
export const ClassNameF56f3184379341faBf2659bd1b6c9aa9 = "public-header-with-hero secondary-page";

// id: "596212ca-0c5c-49e0-ae7d-5df846d4b824"
// title: ""
// type: :text
// key: "as"
// parent_id: "2892b866-ab8c-47d8-9674-7dd8ad0c3d36"
export const As596212ca0c5c49e0Ae7d5df846d4b824 = "header";

// id: "d54f0b0e-a0e0-4eac-93ed-710d652a05fd"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "6fb449f3-46a3-4f67-a737-c659e158928a"
export const PostSlugD54f0b0eA0e04eac93ed710d652a05fd = "polytopia-2026-cards";

// id: "1a2bd1dc-6e5d-4ed1-ae98-a8e79f50c560"
// title: ""
// type: :reference
// key: "header"
// parent_id: "27ebb718-2df7-42ba-a258-1b7815e0e4ef"
export function Header1a2bd1dc6e5d4ed1Ae98A8e79f50c560(props: any) {
  return (
    <HomeHeader13343270Aaef4ba9A0048f74b7d0702d parentTag="Header1a2bd1dc6e5d4ed1Ae98A8e79f50c560" {...props} />
  );
}

// id: "72421d8b-740d-40bb-97d2-a03507bc304d"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "f9d2c204-ca51-4b8b-a2a4-a44a7305a5fd"
export function HeaderTop72421d8b740d40bb97d2A03507bc304d(props: any) {
  return (
    <DefaultHeaderTopB6c2307bD6814f14A258B20d9016e163 parentTag="HeaderTop72421d8b740d40bb97d2A03507bc304d" navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "69ac436a-dca7-4c14-9f3d-92b917f10b67"
// title: ""
// type: :text
// key: "title"
// parent_id: "5d1635a4-4895-46fa-a462-10994027b300"
export const Title69ac436aDca74c149f3d92b917f10b67 = null;

// id: "524ed796-02b9-458f-bb09-ee30af38e811"
// title: ""
// type: :gf_preset
// key: "main-content"
// parent_id: "b93fa53c-0235-4c33-a2a7-4b3bfe6b8464"
export function MainContent524ed79602b9458fBb09Ee30af38e811(props: any) {
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageContentSimplified className="MainContent524ed79602b9458fBb09Ee30af38e811" parentTag={buildClassName("MainContent524ed79602b9458fBb09Ee30af38e811", parentTag)} contentSlug="polytopia-2026-workshops-content" {...props} />
  );
}

// id: "62424f9e-3290-4d87-ab12-646d943daf66"
// title: "Marketing Primary Navigation"
// type: :text
// key: "navMenuSlug"
// parent_id: "5d1635a4-4895-46fa-a462-10994027b300"
export const NavMenuSlug62424f9e32904d87Ab12646d943daf66 = "marketing-primary-nav";

// id: "650066db-77e0-45b4-abe9-d45ab9db96bf"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "5ec7c6f3-59ad-4407-9daa-22ac0d484146"
export const ContentSlug650066db77e045b4Abe9D45ab9db96bf = "polytopia-2025-schedule-main";

// id: "1fce7a43-a3e2-43d8-b7aa-34b28192db42"
// title: ""
// type: :text
// key: "as"
// parent_id: "7acf5ec7-41ce-4350-8e6b-fefa72e3f7c3"
export const As1fce7a43A3e243d8B7aa34b28192db42 = "header";

// id: "312caffa-19e0-45f8-851d-40d6c3c32811"
// title: ""
// type: :text
// key: "title"
// parent_id: "57268d69-2a46-4de9-abaf-033dab4ad77b"
export const Title312caffa19e045f8851d40d6c3c32811 = "Leveling";

// id: "66ae2a14-a597-4d3b-9d61-18e7bdc4d413"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "5d3c2318-7ce5-4424-9793-be7d03075b28"
export const PostSlug66ae2a14A5974d3b9d6118e7bdc4d413 = "home-page-posts2";

// id: "2c37732a-733f-4cc3-a5d6-2ad7b6321bae"
// title: ""
// type: :text
// key: "className"
// parent_id: "95e743a8-acec-4d29-881a-8e5ae3f0995e"
export const ClassName2c37732a733f4cc3A5d62ad7b6321bae = "intro-text";

// id: "9ff797c3-b574-4e40-bb51-b9b6755a103a"
// title: ""
// type: :gf_preset
// key: "social-links"
// parent_id: "6d28a864-391b-46b0-8e2e-ce2784eb6f17"
export function SocialLinks9ff797c3B5744e40Bb51B9b6755a103a(props: any) {
  const SocialLinks = AppStore.presets["SocialLinks"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <SocialLinks className="SocialLinks9ff797c3B5744e40Bb51B9b6755a103a" parentTag={buildClassName("SocialLinks9ff797c3B5744e40Bb51B9b6755a103a", parentTag)} postSlug="footer-social-links" {...props} />
  );
}

// id: "5ac41609-ce36-402d-84a9-d3f221404b62"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "67f6f45b-0883-4561-b89e-9c3cc608e0df"
export function Sponsors5ac41609Ce36402d84a9D3f221404b62(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="Sponsors5ac41609Ce36402d84a9D3f221404b62" parentTag={buildClassName("Sponsors5ac41609Ce36402d84a9D3f221404b62", parentTag)} {...props} />
  );
}

// id: "c0f25d4b-f86a-46aa-b0b8-bd4c9bda9ecb"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "64a547e5-2697-4305-89f9-d0aef2a273c7"
export function SponsorsC0f25d4bF86a46aaB0b8Bd4c9bda9ecb(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="SponsorsC0f25d4bF86a46aaB0b8Bd4c9bda9ecb" parentTag={buildClassName("SponsorsC0f25d4bF86a46aaB0b8Bd4c9bda9ecb", parentTag)} {...props} />
  );
}

// id: "f1ead838-8e7d-4d56-9957-87255a036308"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "27ebb718-2df7-42ba-a258-1b7815e0e4ef"
export function QuoteF1ead8388e7d4d56995787255a036308(props: any) {
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="QuoteF1ead8388e7d4d56995787255a036308" parentTag={buildClassName("QuoteF1ead8388e7d4d56995787255a036308", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "57268d69-2a46-4de9-abaf-033dab4ad77b"
// title: ""
// type: :reference
// key: "header"
// parent_id: "5960a13a-bea8-4838-af13-ca4ddfbdaeb6"
export function Header57268d692a464de9Abaf033dab4ad77b(props: any) {
  return (
    <SecondaryMarketingHeader46e8287a4bfb4421A3bdAdd5b7823e32 parentTag="Header57268d692a464de9Abaf033dab4ad77b" title="Leveling" {...props} />
  );
}

// id: "ac10e005-854d-4314-9644-9a4577d50edf"
// title: ""
// type: :text
// key: "as"
// parent_id: "9761af07-bc2d-4c8d-afc6-1172ab1207c8"
export const AsAc10e005854d431496449a4577d50edf = "header";

// id: "05c600e8-29e3-4041-bf64-45bfb12b39bc"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "1e601535-765c-49f1-8ebe-565b8e4395f2"
export const ContentSlug05c600e829e34041Bf6445bfb12b39bc = "polytopia-2026-handouts-main";

// id: "d9300e0b-2210-407a-8b7b-1b15a5ed023a"
// title: ""
// type: :text
// key: "as"
// parent_id: "1cd15230-2613-4410-a64d-86765a0fc3e9"
export const AsD9300e0b2210407a8b7b1b15a5ed023a = "header";

// id: "26f99bc8-3a26-4fb0-8af5-8b525a8c3293"
// title: ""
// type: :text
// key: "className"
// parent_id: "1cd15230-2613-4410-a64d-86765a0fc3e9"
export const ClassName26f99bc83a264fb08af58b525a8c3293 = "public-header-with-hero secondary-page";

// id: "163ca03a-ae8e-434b-9112-3c65cee9700d"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "b6c2307b-d681-4f14-a258-b20d9016e163"
export function LinkedLogo163ca03aAe8e434b91123c65cee9700d(props: any) {
  const Link = AppStore.presets["Link"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo163ca03aAe8e434b91123c65cee9700d" parentTag={buildClassName("LinkedLogo163ca03aAe8e434b91123c65cee9700d", parentTag)} label={<DefaultLogo61ee95b52f514b33A182C65924ce10ad parentTag="LabelC97f69a364b343d5956c9becc05b7e1c" alt="logo" />} className="linked-logo" url="/" {...props} />
  );
}

// id: "82b1577f-f78b-407d-b3ea-e0e2498cee99"
// title: ""
// type: :gf_preset
// key: "sponsors"
// parent_id: "77f22cd6-ae63-49b9-ae76-f1f1c696d4b5"
export function Sponsors82b1577fF78b407dB3eaE0e2498cee99(props: any) {
  const ContentSnippet = AppStore.presets["ContentSnippet"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="Sponsors82b1577fF78b407dB3eaE0e2498cee99" parentTag={buildClassName("Sponsors82b1577fF78b407dB3eaE0e2498cee99", parentTag)} {...props} />
  );
}

// id: "cce9cc59-87a6-4a32-8339-3b93d7e0c2f5"
// title: ""
// type: :reference
// key: "header"
// parent_id: "cdf4c839-0b3f-4051-a040-be65b6e59fa0"
export function HeaderCce9cc5987a64a3283393b93d7e0c2f5(props: any) {
  return (
    <SecondaryMarketingHeader46e8287a4bfb4421A3bdAdd5b7823e32 parentTag="HeaderCce9cc5987a64a3283393b93d7e0c2f5" title="Join Us" {...props} />
  );
}

// id: "551e0397-50c7-49c2-b65b-01c58185db98"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "46e8287a-4bfb-4421-a3bd-add5b7823e32"
export function Hero551e039750c749c2B65b01c58185db98(props: any) {
  return (
    <SecondaryMarketingHeroD85a52024c284d7f8df2671b4d39473a parentTag="Hero551e039750c749c2B65b01c58185db98" title="Secondary Marketing Title 2" {...props} />
  );
}

// id: "311cfa73-b444-468d-b3a0-ee9881d4773a"
// title: ""
// type: :text
// key: "as"
// parent_id: "baef190d-6110-483b-a204-8916d38c11d3"
export const As311cfa73B444468dB3a0Ee9881d4773a = "header";

// id: "2c284c4c-fc8a-4dd1-9857-53717594aef6"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "2892b866-ab8c-47d8-9674-7dd8ad0c3d36"
export const ContentSlug2c284c4cFc8a4dd1985753717594aef6 = "polytopia-2025-workshops-header-with-hero";

// id: "824ab7fd-5cb3-4328-b56d-a7b3b32e1835"
// title: ""
// type: :text
// key: "as"
// parent_id: "f87a6608-a300-475c-8ae7-df08bbbc1158"
export const As824ab7fd5cb34328B56dA7b3b32e1835 = "header";

// id: "3eef4ca7-b581-498b-8d21-8c2e7fd390a6"
// title: ""
// type: :text
// key: "className"
// parent_id: "f6420103-9f71-4cc8-8193-b7f48567090f"
export const ClassName3eef4ca7B581498b8d218c2e7fd390a6 = "public-header-with-hero secondary-page";

// id: "bd740e6a-5b15-4676-97df-c007bf772d84"
// title: ""
// type: :text
// key: "as"
// parent_id: "03159174-a34f-4b94-a8dc-70fec2708368"
export const AsBd740e6a5b15467697dfC007bf772d84 = "header";

const Components = {
  Polytopia2025Presenters161ec63b1b36486eB50e3fce09959017,
  FooterE635450e5253445aB71e02ef84358c46,
  MembersAreaDefaultA37c2102173c4d49A14aF3f10597a1f5,
  MembersAreaHeaderF9d2c204Ca514b8bA2a4A44a7305a5fd,
  DefaultHeaderTopB6c2307bD6814f14A258B20d9016e163,
  MarketingCardsB5bdf19784c64598Ba9aE3cca29275dd,
  Polytopia20242c6604e03fd44a62A69910a54631f001,
  SignupPages314318310fb14e5f880bB30691a5f62e,
  Polytopia2026ScheduleBf094e87989147189d43654487499262,
  Polytopia2026PresentersA4867a33B561450d85a936f67e3845ab,
  MemberPagesA205bb2d69d341148f06D8094dda6655,
  ResourcesPage0ca15a34Ab6e4dc09e8d8d582e9365e6,
  Logo23f825d3Eb904c2cAad85622b537408d,
  FooterB2e1337dA9e843cc99b91aaab7960131,
  TitleDcc18c6b0e1c4998B76f0fd4ea742e89,
  SponsorsE702a3b254f14a0bAa3cC07e89d2fa73,
  Header269840180df94a1fB9e2Bb3426a5ee92,
  SubType7c7b8063299d4c53Bc2d7bfd59013bac,
  ContentSlug044e6bc5A4864148B9c8599c081e7782,
  Title85c6ff7cFc7f42079e005b4a8804ac1f,
  ContentSlug486f46ffE3214c9cB00aFf84f4929b0d,
  ContentSlug146c9c90De4045ff87e4513bd79fe176,
  Polytopia2026Handouts7d24c00a3e5145c385012d4fd3079d1f,
  Polytopia2025Workshops67f6f45b08834561B89e9c3cc608e0df,
  MarketingBody5e4b61e6136b4c329be890b33fbc406b,
  SponsorsCba5188368d34072880aAafa4c988982,
  HeaderF87a6608A300475c8ae7Df08bbbc1158,
  NavigationB53e0845F2574f93A6fd08db6ab675ac,
  Hero539b6810145a4403Bb2a849d0a68fb45,
  SecondaryNavC57ee9929a8d4859Bfbf1361c65f0e92,
  PostSlug93156f4b070543fbAbf2Ac2afb0e2aab,
  NavMenuSlug8338ddb9F60b43279f86F1f01d6e3daa,
  ContentSlug14ba31f65fc94a79Bd729ca153e6a128,
  Href020b79174532403888d5Bab5474c15f4,
  ClassNameEf47152b0f14403180c4A7490af14808,
  Polytopia2026Sponsors64a547e52697430589f9D0aef2a273c7,
  MessagePages51196b2476d24b11Bfe5F3accc666a93,
  Polytopia2026Df06157b080e4a949534D6fd5e4e141c,
  PostSlug12b9031620c945568f3f2d95c563c0d0,
  Header1cd1523026134410A64d86765a0fc3e9,
  NavigationAf40ecc3685646f7B38eDfee76dd4b1c,
  HeaderB9b7eae57d3348a7B4edC1c529a55440,
  Footer5a1d513288c748df8e1fF04eaea92173,
  ClassName7a179810387f412a89da3596bc3634bd,
  ContentSlug5da41394A49f441fA25eFfe423e0a009,
  ContentSlug42121220Ab344631B6daF6a965dc8709,
  LabelC97f69a364b343d5956c9becc05b7e1c,
  PostSlugFc68199a9b7d4771A05b38b0670f42a7,
  DefaultFooter6d28a864391b46b08e2eCe2784eb6f17,
  DefaultHeader5d1635a4489546faA46210994027b300,
  Polytopia2025Handouts1018f660F5d1490eA4862d1112478006,
  Sponsors168afb7674c84d6e846f0b3a8e7e88de,
  Header64031602878b4189B772475df5163551,
  BackgroundImage82133fc079a74da889eb43562ccb2e78,
  BodyCa7acaeb54014709Bc40E751735ca206,
  WelcomeBack14a06d70B335433c87868ff6c23dbb99,
  SubType46348aae0aa94aee8328Affac296bcdc,
  Title91cc0c80091743598ac8B74c632591d3,
  SubType14bd94ddB68c4c8e9f8eBea7ee3bb417,
  ContentSlugFc34f6d5Ef65443e900f36992e4b26b9,
  ClassName07bead84Fd8e40528020D283a36d2f84,
  DefaultLogo61ee95b52f514b33A182C65924ce10ad,
  SecondaryMarketingHeroD85a52024c284d7f8df2671b4d39473a,
  AdminPages4d0bc7a0299047a8A2f34c341e885d57,
  ImageUrl767039e6Ef684393B08829c4047eed12,
  HeaderD14c9e7f570242d08256D2c1aed5f858,
  Polytopia2025Sponsors77f22cd6Ae6349b9Ae76F1f1c696d4b5,
  Header962c7d0b1d5c41f8Bf56Fa72373b342d,
  SponsorsB1303089895d4c8dAd6fC4c9678d303d,
  FooterBc6d66770ac7463bA935Bfa4fb213407,
  Footer5071c4adD91440a18a1f22f710551a4b,
  HeaderA3c1651dF4634b359ce1C094693dba72,
  SubTypeE799950c28844a6390058d46cb3fc2a2,
  Title1c3dafa3285342abB163Dbd287120263,
  PostSlugF670aa5945654394A87258c46e069dad,
  SubTypeDfa12350Ea6846348fb9Add07ab64450,
  ClassName4c2bd48022ba4765Ba2f54551cf2b1e6,
  SecondaryMarketingHeader46e8287a4bfb4421A3bdAdd5b7823e32,
  JoinUsPageCdf4c8390b3f4051A040Be65b6e59fa0,
  CardsDfeae2f2573645ca8f3947425390e9e8,
  MarketingCards5d3c23187ce544249793Be7d03075b28,
  MainContent1e601535765c49f18ebe565b8e4395f2,
  SponsorsAc89e108885e4434B26429668083e15a,
  Intro09504972F2024eaf8d142331563059cc,
  HeaderTop4df8f5a81a49421e9632Ef2ed7ab1247,
  PostSlug378f43778e524570A362Cbb5b4559640,
  ContentSlugAf2f18c4Bd744e6fA2588fd09bdff3b2,
  ContentSlug3bbc3f42Efab4fd0Ac111e6aac5caac1,
  Title412551ad3f1745a0B015D88124cacaa7,
  ContentSlugB0faedd08b8c453397a514dd9102962f,
  SecondaryPage4cefad8cDd5f490584929ab0bffa628b,
  Title5e4082e24d05474cBc95Fa01c3a2d009,
  Footer16c0ad24C654436dAed26658a7d90cc8,
  BackgroundImage7b809bf6Fadd48e193cd0f7b523ff426,
  MainContent501ee711Ff3f45a5A7a108d57a08acd4,
  HeaderBaef190d6110483bA2048916d38c11d3,
  MainContent5ec7c6f359ad44079daa22ac0d484146,
  CardsB40f2d0a99d04cd2A2558f76555a3c20,
  NavMenuSlug92bf3bf94d9a4ede9271Ae6af31aec49,
  ClassNameF7aee0faFf7c491e84b22c8bebf3bd12,
  Title4df2d428000a4b85A5154e46658ab12f,
  ContentSlugE83ce1e23424498d8646D4c3fa14a85a,
  AsB0259339Ab0e4dadBd7e4b5862239688,
  ShortHeader23d209925bf248b39101Af66f3618c42,
  PublicEventsPageC7b3a7b5B04f4457A2beCa2f064fa800,
  Sponsors994b498678ab4035B2925bd122781f94,
  MainContent66f1cd583f714f72841d1ab5d051be67,
  HeaderA75825ab16ea4b46875944fd1e10c499,
  Header501fc3bcCa974cde91f7Cbd4d7ba33e6,
  Button791e01b10502434595837d0461dc458a,
  ButtonClassF8e6838762ac497fA4415fa8504f3532,
  PostSlugFda3b7f8855e43b0A1bcD8679efa709a,
  ClassNameC9f372374c44484eAd96104e6bd05901,
  ContentSlugEd1183eb11b54022B5d45887af34d301,
  As8d2be3501f3a4de4Ba4d75148b50e524,
  Title9c57a08bF6514b6aA4f8Ca91f8dcc91e,
  AboutUsPage3538a127Aa334e0590c1D5d4f38c6467,
  Href9ec12065Efa74e60Bc846e6f1cd50f38,
  Sponsors24e32cc43d544ba887acB80c8b270717,
  Footer5df4a4ad93b24322B06a1e233b044515,
  FooterFa77a35fA4d644a5A4065d41a36addf1,
  Header5377d850007f45aaB5e15e86f61be8ab,
  FooterBf2025ba94f04a348106A31f1afff587,
  CopyrightB1fba87dF7ed4567Aa6d596b27ee9ac7,
  ClassName189cd85cF9dd465dB279Adf3a8049e0c,
  SubTypeA15a4a85D2a24f79Aec8959fd8fc9ccd,
  As3bf58868Ec1a4da8B8aaE2c5dc2c907d,
  NavMenuSlug5fc0225dB08b440d8ab533a459afb2d6,
  ClassName04defbdeFc934d5b81d2A1f4784e99e3,
  HomeHeader13343270Aaef4ba9A0048f74b7d0702d,
  HomePageHero280ad86c331c4a3eBf8dCcfd86ecff1d,
  Groupflow1c69407b3fdf4b3995e74c9e3b125231,
  Polytopia2025Schedule96c941543a2347eeA6333f74c461ed62,
  HomePage27ebb7182df742baA2581b7815e0e4ef,
  FooterB627bba7D38149a0A1a7C1152e4938f6,
  HeaderDdb7077fA7654a1d8bb0Da405d0a90a8,
  MainContent902d49a9867d469197a36c227cb214db,
  Footer443833d8Fbb5467581f54266d91b7df0,
  Header03159174A34f4b94A8dc70fec2708368,
  ContentSlug4cd242ea76ab497cA8445b45e1efef2b,
  ClassEcc8abf3Dd0f4ecc83e652c5313d8445,
  TitleC5b279f4F19249a4903c456ee01b5a02,
  ContentSlug797439c3Fc5f4ca787c6Ccc0c0ec1431,
  Url50867fc80d394caa9d07Aabad31b5306,
  PageQuoteBd07d0e7D7b6404e8f585e536f2480ed,
  Polytopia2026WorkshopsB93fa53c02354c33A2a74b3bfe6b8464,
  Footer0ef54779Cb7649ccBf066b9d2d9af470,
  Header487b8ff06565488882df11125c29fce5,
  Header8f4a57b77c80412091a121e9c1c38d7b,
  Cards6fb449f346a34f67A737C659e158928a,
  ContentSlugCc2ee07d925e48faA344D1b4d8325012,
  ContentSlug011666d44c5d49fb900bA737bd4a706d,
  PostSlugEf45f7965a6243b4Bb4dBfd24de6486b,
  SubType3be555e2C82b47deB2e18e8174be14f8,
  AboutLevelingPage5960a13aBea84838Af13Ca4ddfbdaeb6,
  HeaderF64201039f714cc88193B7f48567090f,
  Header9761af07Bc2d4c8dAfc61172ab1207c8,
  HeaderBe9a936fF4ef404fB5feDa9b95a18828,
  HeaderA08faa137d9c4bbf9352Ff58a8439fc3,
  Body2a4842cfA3b14e419bc1Fd8dc26188f8,
  Body516d7bfbB25b4173A1a66fdeb815cdb4,
  ContentSlugD166df3fE30c4c21Abd26b92930810cd,
  ContentSlug796fe704E2fc44b6Ac1f9da1ff3579db,
  NavMenuSlug99b6f8aeE293461e83183b170d6f8095,
  LabelFc90cbb74dd84165Acd26faa81729288,
  SubTypeD5e2dcb1Da464d2bAf06Be8d96db12ef,
  Polytopia2024Workshops67429ef05c42457aA9aeD89ea03fd5ea,
  CardsCae48e4aD8ab4484Afe97c2058b2e7e3,
  LinksF10eadf8147f4cff924085839b329cd8,
  FooterA18ad67e27934c639a5bE5fc84c36d63,
  Footer2735cda8A2a3475e81984baf37ebb4bd,
  Footer9610b3127ecb47acA5a2Cc3017b7974b,
  Footer2a2d3898C2ea4e5e9ad11536335d77f7,
  ClassNameBbe38b659566458b8c6bAab3653cc136,
  SubType78fa82d649aa447f95ca161528c087be,
  PostSlug00404a42530044b18697F32ff92e3205,
  Title3691ebba2c554760B3fb797f7119c6a1,
  LabelBdada434000045fbA227255ae16de7d2,
  Polytopia2025106561f46b134d2e93b8980dbecda65c,
  Cards22c216b0214548999f101a141bf14483,
  FooterD2d37f8a8ab04b1bAd124dc21d463dd4,
  Header597719ea4fc9492cBc0395666caf81d8,
  FooterF85d344cFc5a4722B1b1Cfec30d7810e,
  Title1e33bc02924b454e9974Eb8dbe154fa6,
  LinkedLogo5a315d7c2f4d4cd3923aE0bd231c8386,
  NavMenuSlugBb9fe71dFe5b40319f4c0e6a8421dc06,
  PostSlugB759dff1674c4e97903b07575f07e6a6,
  PostSlugA0e4a7c173f349f9A063C3f696fb39fe,
  SubTypeB41acd2679e948de90fb8523c1c93428,
  Label1cdfc5b30906437e993eF87d9b418138,
  Header7acf5ec741ce43508e6bFefa72e3f7c3,
  Footer57ac424f10d44853Ad47C3ae22149f16,
  HeaderTop1b708421937b491f995b83b9957943fd,
  Footer9683a88fE78644bdB33cEfaa37c55090,
  FooterEd22b18668644af0Ba43A5f4515ace0f,
  ClassName9a64e7ce3f0844fc92414d591d8eca13,
  As695781b2Cc4040e3Bcea7c61c121a83a,
  SubType7964f7654b3d4327A83581b488e5e5c4,
  As0cb6889aC95b4acf9f77Dc4e6578a87b,
  SubTypeD69fb03d7dae438dAedc7d23e118c7c0,
  Intro95e743a8Acec4d29881a8e5ae3f0995e,
  SponsorsEb50e0a2B0614f97850aF6b9008b129c,
  Intro802d08a7582148719f0bA58951f4df72,
  AltD73cf288D983455796c288167aaf88ac,
  IntroA1b4a8cdB6174450A3a52fb4e8795a41,
  Class0ff005b234e14cfc8ccc13bd7dd26d97,
  ContentSlug9a2881ab2c9e4945825fE6bcff4241c4,
  Title4c186061C0aa48269b32Bce6a5d19349,
  Title6bf192b42f864aaeB1c734806b92e8c3,
  ContentSlug634bce0036064c738b5709f85463ff92,
  Body6809bc81F7004207A1e7328015756367,
  Cards49c5dba9Edc5491dB9cf622db50f5735,
  SponsorsEc095376B5e74bd6A44f84e988e3c4a2,
  Footer623956c8733d48149568C62575c38f65,
  Header2892b866Ab8c47d896747dd8ad0c3d36,
  ContentSlugBad9107aC30a42129ea06a656d4cfe2c,
  ContentSlugA1de058b987f4ecfAa54F146746c9dbb,
  ClassNameF56f3184379341faBf2659bd1b6c9aa9,
  As596212ca0c5c49e0Ae7d5df846d4b824,
  PostSlugD54f0b0eA0e04eac93ed710d652a05fd,
  Header1a2bd1dc6e5d4ed1Ae98A8e79f50c560,
  HeaderTop72421d8b740d40bb97d2A03507bc304d,
  Title69ac436aDca74c149f3d92b917f10b67,
  MainContent524ed79602b9458fBb09Ee30af38e811,
  NavMenuSlug62424f9e32904d87Ab12646d943daf66,
  ContentSlug650066db77e045b4Abe9D45ab9db96bf,
  As1fce7a43A3e243d8B7aa34b28192db42,
  Title312caffa19e045f8851d40d6c3c32811,
  PostSlug66ae2a14A5974d3b9d6118e7bdc4d413,
  ClassName2c37732a733f4cc3A5d62ad7b6321bae,
  SocialLinks9ff797c3B5744e40Bb51B9b6755a103a,
  Sponsors5ac41609Ce36402d84a9D3f221404b62,
  SponsorsC0f25d4bF86a46aaB0b8Bd4c9bda9ecb,
  QuoteF1ead8388e7d4d56995787255a036308,
  Header57268d692a464de9Abaf033dab4ad77b,
  AsAc10e005854d431496449a4577d50edf,
  ContentSlug05c600e829e34041Bf6445bfb12b39bc,
  AsD9300e0b2210407a8b7b1b15a5ed023a,
  ClassName26f99bc83a264fb08af58b525a8c3293,
  LinkedLogo163ca03aAe8e434b91123c65cee9700d,
  Sponsors82b1577fF78b407dB3eaE0e2498cee99,
  HeaderCce9cc5987a64a3283393b93d7e0c2f5,
  Hero551e039750c749c2B65b01c58185db98,
  As311cfa73B444468dB3a0Ee9881d4773a,
  ContentSlug2c284c4cFc8a4dd1985753717594aef6,
  As824ab7fd5cb34328B56dA7b3b32e1835,
  ClassName3eef4ca7B581498b8d218c2e7fd390a6,
  AsBd740e6a5b15467697dfC007bf772d84
}

export default Components;